<template>
  <div class="main_pages">
    <div class="share" @click="appshare"></div>
    <div class="activityRules" @click="showRules"></div>
    <div class="ActivityAwardbox">
      <van-image
        width="100%"
        fit="contain"
        class="ActivityAward"
        src="https://activity-1254361794.file.myqcloud.com/outsource/prize/ActivityAward.png"
      />
    </div>
    <div class="Awardcoverbox">
      <div class="scroller">
        <div class="cover">
          <van-image fit="contain" class="banner"  src="https://activity-1254361794.file.myqcloud.com/outsource/prize/banner0.png"/>
          <!-- <div class="cover-title">购买VIP获得打榜票数</div> -->
        </div>
        <div class="cover">
          <van-image fit="contain" class="banner" src="https://activity-1254361794.file.myqcloud.com/outsource/prize/banner1.png"/>
          <!-- <div class="cover-title">第1名演员奖励</div> -->
        </div>
        <div class="cover">
          <van-image fit="contain" class="banner" src="https://activity-1254361794.file.myqcloud.com/outsource/prize/banner2.png"/>
          <!-- <div class="cover-title">第2名演员奖励</div> -->
        </div>
        <!-- <div class="cover">
          <van-image
                fit="contain"
                class="banner"
                 src="https://activity-1254361794.file.myqcloud.com/outsource/prize/banner3.png"
              />
           <div class="cover-title">第1名演员奖励</div>
        </div>-->
      </div>
    </div>
    <div class="userbox">
      <div class="users_avtar" @click="loginOut">
        <van-image width="100%" fit="contain" class="image" :src="userAvatar"/>
      </div>
      <div class="userInfo" v-if="logined">
        <div class="nicknamess colors" @click="loginOut">{{nickname}}</div>
        <div class="brick color">今天还剩{{userbricknum}}心心</div>
      </div>
      <div class="userInfos" v-if="logined == false">
        <div class="nicksname">请登录后参与投票</div>
      </div>
      <div class="logsin" v-if="logined == false" @click="showPopup">登录</div>
      <div class="gisves" v-if="logined" @click="showbuyModal()">购买
        <van-image fit="contain" class="givesIcon" src="https://activity-1254361794.file.myqcloud.com/outsource/prize/star.png"/>
        <div class="vipIcon"></div>
      </div>
    </div>
    <div class="sharenumbox" v-if="isOut == false && logined">
      <div class="sharetitle">每天前5次分享每次可得5心心</div>
      <div class="sharetitles">今天已分享：</div>
      <div class="sharenum">{{shareSuccessTimes}}/5</div>
      <div class="sharebutton" @click="appshare">去分享</div>
    </div>
    <div class="sharenumbox" v-if="isOut && logined">
      <div class="sharetitle">打开埋堆堆APP，分享好友可获得更多心心哦~</div>
    </div>
    <div class="Celebrityrankingbox">
      <van-image
        width="100%"
        fit="contain"
        class="ActivityAward"
        src="https://activity-1254361794.file.myqcloud.com/outsource/prize/Celebrityranking.png"
      />
    </div>
    <div class="Topbox">
      <div class="Maleleader">
        <div class="Maleleader_avatar">
          <van-image width="100%" fit="contain" class="image" :src="manstar.startImg"/>
        </div>
        <div class="starsInfo">
          <div class="name">
            {{manstar.startName}}
            <div class="name_line"></div>
          </div>
          <div class="stars">
            <div class="star">
              <van-image
                fit="contain"
                class="starss"
                src="https://activity-1254361794.file.myqcloud.com/outsource/prize/star.png"
              />
              <div class="xinnumber">x{{manstarnums}}</div>
              <!-- <van-image
                fit="contain"
                class="starsnums"
                :src="require('https://activity-1254361794.file.myqcloud.com/outsource/prize/x.png')"
              />
              <div class="Icon" :class="item.name == 'dian'?'dians':''" v-for="item in manstarnum" :key="item.id">
                <van-image
                  fit="contain"
                  class="starnum"
                  :class="item.name == 'dian'?'dian':''"
                  :src="require('https://activity-1254361794.file.myqcloud.com/outsource/prize/' + item.name + '.png')"
                />
              </div>
              <div class="Icon" v-if="manstar.heartNumber > 9999">
                <van-image
                      fit="contain"
                      class="starnums"
                     :src="require('https://activity-1254361794.file.myqcloud.com/outsource/prize/k.png')"
                    />
              </div>-->
            </div>
          </div>
        </div>
      </div>
      <div class="Femaletop">
        <div class="starsInfo">
          <div class="Femaletop_name">
            {{womanstar.startName}}
            <div class="Femaletop_name_line"></div>
          </div>
          <div class="stars">
            <div class="Femaletop_star">
              <van-image
                fit="contain"
                class="starss"
                src="https://activity-1254361794.file.myqcloud.com/outsource/prize/star.png"
              />
              <div class="xinnumber">x{{womanstarnums}}</div>
              <!-- <van-image
                fit="contain"
                class="starsnums"
                :src="require('https://activity-1254361794.file.myqcloud.com/outsource/prize/x.png')"
              />
              <div class="Icon" :class="item.name == 'dian'?'dians':''" v-for="item in womanstarnum" :key="item.id">
                <van-image
                  fit="contain"
                  class="starnum"
                  :class="item.name == 'dian'?'dian':''"
                  :src="require('https://activity-1254361794.file.myqcloud.com/outsource/prize/' + item.name + '.png')"
                />
              </div>
              <div class="Icon" v-if="womanstar.heartNumber > 9999">
                <van-image
                      fit="contain"
                      class="starnums"
                     :src="require('https://activity-1254361794.file.myqcloud.com/outsource/prize/k.png')"
                    />
              </div>-->
            </div>
          </div>
        </div>
        <div class="Femaletop_avatar">
          <van-image width="100%" fit="contain" class="image" :src="womanstar.startImg"/>
        </div>
      </div>
    </div>
    <div class="Dividingline">
      <!-- <div class="white"></div> -->
      <div class="mantop">NO.1</div>
      <div class="womantop">NO.1</div>
    </div>
    <div class="starNav">
      <div class="malecelebrity" @click="showmalecelebrity">最受欢迎男主角
        <div :class="starActive?'starActive':''" class="ActiveLine"></div>
      </div>
      <div class="malecelebritys" @click="showmalecelebritys">
        <div :class="!starActive?'starActive':''" class="ActiveLine"></div>最受欢迎女主角
      </div>
    </div>
    <div class="ranksbox">
      <div class="ranklist" v-for="item in episodesList" :key="item.id">
        <div class="Starranking">
          <div class="TOPIcon">TOP</div>
          <div class="rankingbox">
            <!-- <div class="ranking" > -->
            <van-image
              v-for="(items,index) in item.no"
              :key="items.id"
              :class="index == 1?'position':''"
              fit="contain"
              class="ranks"
              :src="'https://activity-1254361794.file.myqcloud.com/outsource/prize/' + items.name + '.png'"
            />
            <!-- </div> -->
          </div>
        </div>
        <div class="starAvatar">
          <van-image width="100%" fit="contain" class="image" :src="item.startImg"/>
        </div>
        <div class="starinformation">
          <div class="starname">{{item.startName}}</div>
          <div class="starsNum">
            <van-image
              fit="contain"
              class="starsIcon"
              src="https://activity-1254361794.file.myqcloud.com/outsource/prize/star.png"
            />
            {{item.numberOfProps}}
          </div>
        </div>
        <div class="Giveoutstars" @click="showConfirmPopup(item.sort,item.id,'star')">
          <span class="Giveoutstarss">送出</span>
          <van-image
            fit="contain"
            class="GiveoutstarsIcon"
            src="https://activity-1254361794.file.myqcloud.com/outsource/prize/star.png"
          />
        </div>
      </div>
      <div class="more" @click="addmore" v-if="isOver == false">点击加载更多</div>
    </div>
    <div class="starNav">
      <div class="smalecelebrity" @click="showEpisodes">最佳剧集
        <div :class="esStatus?'starActive':''" class="ActiveLines"></div>
      </div>
      <div class="smalecelebritys" @click="showFans">
        <div :class="!esStatus?'starActive':''" class="ActiveLiness"></div>粉丝贡献榜
      </div>
    </div>
    <div class="EpisodesListbox" v-if="esStatus">
      <div class="Episode">
        <div class="EpisodesLists" v-for="item in TVList" :key="item.id">
          <van-image fit="contain" class="EpisodesCover" :src="item.episodesImg"/>
          <div class="Episodesnum">
            <van-image
              fit="contain"
              class="EpisodesIcon"
              src="https://activity-1254361794.file.myqcloud.com/outsource/prize/xin.png"
            />
            {{item.numberOfProps}}
          </div>
          <div class="mask"></div>
          <div class="EpisodeCopy">《{{item.episodes}}》</div>
          <div class="Episodestars" @click="showConfirmPopup(item.sort,item.id,'TV')">
            <span class="Giveoutstarss">送出</span>
            <van-image
              fit="contain"
              class="GiveoutstarsIcon"
              src="https://activity-1254361794.file.myqcloud.com/outsource/prize/star.png"
            />
          </div>
        </div>
      </div>
    </div>
    <div class="EpisodesListbox" v-if="!esStatus">
      <div class="ranklist" v-for="item in userList" :key="item.id">
        <div class="Starranking">
          <div class="TOPIcon">TOP</div>
          <div class="rankingbox" :class="item.rank.length > 2?'IconLeft':''">
            <!-- <div class="ranking" > -->
            <van-image
              v-for="(items,index) in item.rank"
              :key="items.id"
              :class="index == 1?'position':''|| index == 2?'positions':''"
              fit="contain"
              class="ranks"
              :src="'https://activity-1254361794.file.myqcloud.com/outsource/prize/' + items.name + '.png'"
            />
            <!-- </div> -->
          </div>
        </div>
        <div class="starAvatar">
          <van-image width="100%" fit="contain" class="image" :src="item.iconUrl"/>
        </div>
        <div class="starinformation">
          <div class="starsname">{{item.nickName}}</div>
          <div class="love">
            <!-- <van-image
              fit="contain"
              class="starsIcon"
              src="https://activity-1254361794.file.myqcloud.com/outsource/prize/star.png"
            />-->
            {{item.loveX}}
          </div>
        </div>
        <div class="Contribution">{{item.numberOfProps}}贡献值</div>
        <!-- <div class="Giveoutstars" @click="showConfirmPopup(item.id)">
          <span class="Giveoutstarss">送出</span>
          <van-image
            fit="contain"
            class="GiveoutstarsIcon"
            src="https://activity-1254361794.file.myqcloud.com/outsource/prize/star.png"
          />
        </div>-->
      </div>
      <div class="more" @click="addmores" v-if="FanisOver == false">点击加载更多</div>
    </div>
    <div class="login-box" v-if="isOut">
      <div class="mddlogo">
        <van-image
          width="100%"
          fit="contain"
          class="image"
          src="https://activity-1254361794.file.myqcloud.com/outsource/prize/mddlogo.png"
        />
      </div>
      <div class="sharestitle">
        <div class="friendName">{{inviteeName}}</div>邀请你一起瓜分红包
      </div>
      <div class="mddlink" @click="mddlink">
        <van-image
          width="100%"
          fit="contain"
          class="image"
          src="https://activity-1254361794.file.myqcloud.com/outsource/prize/link.png"
        />
      </div>
    </div>
    <van-popup v-model="show" class="external_login">
      <div class="external_login_title">登录埋堆堆账号</div>
      <van-form @submit="onSubmit">
        <van-field v-model="moblie" name="手机号" placeholder="请输入手机号"/>
        <van-field v-model="code" name="验证码" placeholder="请输入验证码">
          <div
            class="codetxt"
            :class="disabled ? 'active':''"
            slot="button"
            :disabled="disabled"
            @click="sendcode"
          >
            <div class="codeline"></div>
            {{btntxt}}
          </div>
        </van-field>
        <div class="logins" @click="onSubmit">登录</div>
      </van-form>
    </van-popup>
    <van-popup v-model="outshow" class="mddOut">
      <div class="mddOut_title">将打开埋堆堆完成购买</div>
      <div class="mddOut_button" @click="openinstall">知道了</div>
    </van-popup>
    <van-popup v-model="popUpPrompt" class="Bulletframe">
      <div class="usershare" v-if="isOut">
        <div class="friendNames">{{inviteeName}}</div>邀请你一起瓜分红包
      </div>
      <div class="Bulletframe_title">恭喜获得{{popUpPromptnum}}票</div>
      <div class="Bulletframe_titles" v-if="isOut == false">每日登陆可得更多心心哦~</div>
      <div class="mddOut_button bottom" @click="hideBulletframe">好的</div>
    </van-popup>
    <van-popup v-model="dateshow" class="mddOut isOut" style="z-index:66666;">
      <div class="mddOut_title">{{tips}}</div>
      <div class="Bulletframe_titles" v-if="isOut">下载埋堆堆APP参与瓜分百万红包</div>
      <div class="mddOut_button" @click="close">好的</div>
    </van-popup>
    <div v-if="dateshow" class="mddOuts"></div>
    <van-popup v-model="loginoutshow" class="mddOut">
      <div class="mddOut_title">确认退出登录？</div>
      <div class="foot">
        <div class="cancel" @click="hideloginoutshow">取消</div>
        <div class="confirm" @click="confirmLogin">退出登录</div>
      </div>
    </van-popup>
    <van-popup v-model="buyStatusshow" class="mddOut">
      <div class="mddOut_title">是否已经完成购买？</div>
      <div class="foot">
        <div class="cancel" @click="hidebuyStatusshow">取消</div>
        <div class="confirm" @click="confirmBuy">已完成购买</div>
      </div>
    </van-popup>
    <!-- 剧集投票排行弹窗 -->
    <van-popup
      v-model="Detailshow"
      round
      position="bottom"
      class="votingdetails"
      @click="hidedetails"
    >
      <div class="sharebox">
        <van-image fit="contain" class="wxshare" src="https://activity-1254361794.file.myqcloud.com/outsource/prize/h5share.png"/>
      </div>
    </van-popup>
    <!-- 购买板砖弹窗 -->
    <van-popup
      v-model="buyModalshow"
      round
      position="bottom"
      class="buy-modal"
      style="z-index: 2002000000;"
    >
      <div class="down" @click="hidebuyModal"></div>
      <div class="title_box">
        <div class="Playtitle">购买
          <van-image fit="contain" class="givesIcon" src="https://activity-1254361794.file.myqcloud.com/outsource/prize/star.png"/>
        </div>
      </div>
      <div class="buy-list-box">
        <div class="buy-list" @click="mddVipRecharge(1)">
          <van-image
            fit="contain"
            class="gift_vip1"
            src="https://activity-1254361794.file.myqcloud.com/outsource/prize/star1.png"
          />
          <!-- <div class="giveaway">
            赠送
            <span class="days">1天</span>VIP会员
          </div> -->
          <div class="give">1元购买</div>
        </div>
        <div class="buy-list" @click="mddVipRecharge(12)">
          <van-image
            fit="contain"
            class="gift_vip2"
            src="https://activity-1254361794.file.myqcloud.com/outsource/prize/star2.png"
          />
          <!-- <div class="giveaway">
            赠送
            <span class="days">30天</span>VIP会员
          </div> -->
          <div class="give">12元购买</div>
        </div>
        <div class="buy-list" @click="mddVipRecharge(40)">
          <van-image
            fit="contain"
            class="gift_vip3"
            src="https://activity-1254361794.file.myqcloud.com/outsource/prize/star3.png"
          />
          <!-- <div class="giveaway">
            赠送
            <span class="days">90天</span>VIP会员
          </div> -->
          <div class="give">40元购买</div>
        </div>
        <div class="buy-list" @click="mddVipRecharge(118)">
          <van-image
            fit="contain"
            class="gift_vip4"
           src="https://activity-1254361794.file.myqcloud.com/outsource/prize/star4.png"
          />
          <!-- <div class="giveaway">
            赠送
            <span class="days">365天</span>VIP会员
          </div> -->
          <div class="give">118元购买</div>
        </div>
      </div>
    </van-popup>
    <van-popup v-model="confirmPopupShow" class="confirmPopup">
      <div class="confirmPopup_title">请选择送出心心数量</div>
      <div class="button_box">
        <div class="button1" :class="selectActive == 1 ? 'select_active':''" @click="select(1)">
          <van-image
            fit="contain"
            class="button_icon"
            src="https://activity-1254361794.file.myqcloud.com/outsource/prize/star.png"
          />x1
        </div>
        <div
          class="button2"
          :class="[userbricknum < 5 ? 'select_actives':'', selectActive == 5 ? 'select_active':'']"
          @click="select(5)"
        >
          <van-image
            fit="contain"
            class="button_icon"
            src="https://activity-1254361794.file.myqcloud.com/outsource/prize/star.png"
          />x5
        </div>
        <div
          class="button2"
          :class="selectActive == userbricknum ? 'select_active':''"
          v-if="userbricknum != 5 && userbricknum != 1"
          @click="select(userbricknum)"
        >
          <van-image
            fit="contain"
            class="button_icon"
            src="https://activity-1254361794.file.myqcloud.com/outsource/prize/star.png"
          />
          x{{userbricknum}}
        </div>
      </div>
      <div class="foot">
        <div class="cancel" @click="hideConfirmPopup">取消</div>
        <div class="confirm" @click="delivery">确认</div>
      </div>
    </van-popup>
    <van-popup v-model="rulesShow" class="rulesBox">
      <div class="rules_title">活动规则</div>
      <van-image
        fit="contain"
        class="line"
        src="https://activity-1254361794.file.myqcloud.com/outsource/line.png"
      />
      <div class="content">
        <div class="content_text">1.用户可通过付费获得心心投票；</div>
        <div class="content_text">2.用户亦可通过登录、分享好友获得心心；</div>
        <div class="content_text">3.用户每日登录活动页可获得5个心心，VIP用户登录可获得10个心心；</div>
        <div class="content_text">4.消耗心心为支持的演员及剧集投票，也可以邀请好友一起投票；每分享一位好友可获得5个心心，每日最多可通过分享好友获得25个心心；</div>
        <div class="content_text">5.活动结束后结算投票成绩，累计获得心心最多的男女主角、最佳剧集将获得奖励。</div>
        <div class="content_texts">活动奖励</div>
        <div class="content_textss">1.明星奖励</div>
        <div class="contents_text ruleLeft">a. 广告位奖励</div>
        <div class="contents_text  ruleLefts">①专属tab（为期1周）</div>
        <div class="contents_text  ruleLefts">②开屏广告、暂停广告（为期1天）</div>
        <div class="contents_text  ruleLefts">③全站banner位置（为期一周）</div>
        <div class="contents_text  ruleLefts">④微信/微博获奖公告</div>
        <div class="contents_text  ruleLeft">b.实物奖杯</div>
        <div class="content_textss">1.粉丝奖励</div>
        <div class="content_text ruleLeft">a. 瓜分百万元红包</div>
        <div class="content_text ruleLefts">①榜单男女主角、最佳剧集第一名对应的贡献用户，按打榜贡献值瓜分现金红包金额</div>
        <div class="content_text ruleLefts">②奖金将在活动结束后5-7个工作日内发放完毕</div>
        <div class="content_text ruleLefts">③获奖用户下载埋堆堆APP即可领取相应奖金</div>
        <div class="contents_text ruleLeft">b. 明星签名照</div>
        <div class="contents_text ruleLefts">贡献榜单前三名获得随机明星签名照一张</div>
        <!-- <van-image fit="contain" class="table" :src="require('https://activity-1254361794.file.myqcloud.com/outsource/prize/table.png')"></van-image> -->
      </div>
      <div class="good" @click="hideRules">好的</div>
    </van-popup>
  </div>
</template>

<script>
import {
  getSimpleMemberInfo,
  getActivityInfo,
  getActivityWebCode,
  getActivityWebLogin
} from "@/request/index";
import openinstallMixin from "@/mixin/openinstallMixin"; // 引入mixin文件
import { dateToyyyymmdd } from "@/common/tool";
export default {
  name: "home",
  data() {
    return {
      isLogin: false,
      rulesShow: false,
      outshow: false,
      starActive: true,
      esStatus: true,
      confirmPopupShow: false,
      Detailshow: false,
      buyModalshow: false,
      userUuid: "",
      userAvatar:
        "https://activity-1254361794.file.myqcloud.com/outsource/default.png",
      nickname: "",
      manstar: {},
      popUpPrompt: false,
      popUpPromptnum: 0,
      manstarnum: [],
      manstarnums: "",
      inviteeName: "",
      womanstar: {},
      womanstarnum: [],
      womanstarnums: "",
      userNum: "",
      moblie: "",
      code: "",
      btntxt: "获取验证码",
      disabled: false,
      time: 0,
      userInfo: {},
      logined: false,
      loginoutshow: false,
      showRule: false,
      showTip: false,
      show: false,
      isBuy: true,
      isOut: false,
      tips: "",
      lbSort: 1,
      gender: 0,
      // vipActivityUuid: window.jump.getUrlStr('vipActivityUuid'),
      platform: window.jump.ios == true ? 0 : 1,
      vipActivityGoodsList: [],
      status: "",
      episodesList: [],
      TVList: [],
      FanisOver: false,
      fanslbSort: 1,
      numIcon: [],
      shareUserId: "",
      overTimeStatus: 0,
      isnomddBuy: "",
      isSellOuntAuth: "",
      saleTimeStatus: "",
      shareSuccessTimes: 0,
      purchasingRightsStatus: "",
      isVersionNameShow: false,
      isVersionName: "",
      isWeixin: false,
      shareSuccessstatus: false,
      shareClick: false,
      desc: "邀请你参加埋堆堆颁奖典礼",
      shareUrl: "",
      typestatus: true,
      leaderboard: {},
      isVodVip: 0,
      giveId: "",
      startId: "",
      isOver: false,
      userbricknum: 0,
      selectActive: 1,
      brickNumber: 1,
      channelNum: "73",
      buyStatusshow: false,
      dateshow: false,
      isclick: true,
      andshow: 0,
      userList: []
    };
  },
  mixins: [openinstallMixin],
  created() {
    var self = this;
    const timestamp = new Date().getTime();
    var search = window.location.search;
    var href = window.location.href;
    if (href != "") {
      var temp2 = href.split("?userId=")[1];
      if (temp2 != "") {
        self.shareUserId = temp2;
        self.$POST(
          "/base/api/heartuser/getInviteeName",
          { inviteeId: temp2 },
          function(res) {
            if (res.errorCode === 0) {
              self.inviteeName = res.body.nickName;
            } else {
              self.$toast(res.msg);
            }
          }
        );
      }
      var pram = href.split('?show=')[1]
      if (pram == 1) {
        self.andshow = 1
      }
    }
    if (self.andshow == 1) {
      this.dateshow = false;
    } else {
      const startTime = 1608739200000;
      const andTime = 1610208000000;
      if (startTime > timestamp) {
        this.dateshow = true;
        this.tips = "活动暂未开始";
      } else if (timestamp > andTime) {
        this.dateshow = true;
        this.tips = "活动已结束";
      }
    }
    // 1602172800000
    self.showicon(4567);

    self.$GET(
      "/base/api/heartEpisodes/getEpisodesRanking",
      { lbSort: 1 },
      function(res) {
        if (res.errorCode == 0) {
          self.TVList = res.body.resultList;
        } else {
          self.$toast(res.msg);
        }
      }
    );
    this.$GET("/base/api/heartuser/getFanRanking", { lbSort: 1 }, function(
      res
    ) {
      if (res.errorCode == 0) {
        res.body.resultList.filter(item => {
          var string = String(item.rank).split("");
          var numIcons = [];
          for (var i = 0; i < string.length; i++) {
            const object = {};
            object.name = string[i];
            object.id = i;
            numIcons.push(object);
          }
          item.rank = numIcons;
          return item;
        });
        self.userList = res.body.resultList;
        // self.womanstar = res.body[0]
      } else {
        self.$toast(res.msg);
      }
    });
    this.$GET(
      "/base/api/heartStarts/getStartRanking",
      { lbSort: 1, type: 1 },
      function(res) {
        if (res.errorCode == 0) {
          res.body.resultList.filter(item => {
            var string = String(item.rank).split("");
            var numIcons = [];
            for (var i = 0; i < string.length; i++) {
              const object = {};
              object.name = string[i];
              object.id = i;
              numIcons.push(object);
            }
            item.no = numIcons;
            return item;
          });
          // self.episodesLists = res.body.rows
          self.womanstar = res.body.resultList[0];
          var data = String(res.body.resultList[0].numberOfProps).split("");
          if (data.length >= 5) {
            var nums = res.body.resultList[0].numberOfProps / 1000;
            var parseNum = nums.toFixed(1);
            var result = parseFloat(parseNum) + "k";
            self.womanstarnums = result;
            var strings = String(result).split("");
            for (var i = 0; i < strings.length; i++) {
              if (strings[i] == ".") {
                strings[i] = "dian";
              }
              // if (i == strings.length - 1) {
              //   strings[i + 1] = 'k'
              // }
              const object = {};
              object.name = strings[i];
              object.id = i;
              self.womanstarnum.push(object);
            }
          } else {
            self.womanstarnums = res.body.resultList[0].numberOfProps;
            for (var i = 0; i < data.length; i++) {
              const object = {};
              object.name = data[i];
              object.id = i;
              self.womanstarnum.push(object);
            }
          }
        } else {
          self.$toast(res.msg);
        }
      }
    );
    this.$GET(
      "/base/api/heartStarts/getStartRanking",
      { lbSort: 1, type: 0 },
      function(res) {
        if (res.errorCode == 0) {
          res.body.resultList.filter(item => {
            var string = String(item.rank).split("");
            var numIcons = [];
            for (var i = 0; i < string.length; i++) {
              const object = {};
              object.name = string[i];
              object.id = i;
              numIcons.push(object);
            }
            item.no = numIcons;
            return item;
          });
          self.episodesList = res.body.resultList;
          var data = String(res.body.resultList[0].numberOfProps).split("");
          if (data.length >= 5) {
            var nums = res.body.resultList[0].numberOfProps / 1000;
            var parseNum = nums.toFixed(1);
            var result = parseFloat(parseNum) + "k";
            self.manstarnums = result;
            var strings = String(result).split("");
            for (var i = 0; i < strings.length; i++) {
              if (strings[i] == ".") {
                strings[i] = "dian";
              }
              const object = {};
              object.name = strings[i];
              object.id = i;
              self.manstarnum.push(object);
            }
          } else {
            self.manstarnums = res.body.resultList[0].numberOfProps;
            for (var i = 0; i < data.length; i++) {
              const object = {};
              object.name = data[i];
              object.id = i;
              self.manstarnum.push(object);
            }
          }
          // var manstarnum = []
          // for (var i = 0; i < strings.length; i++) {
          //   const object = {}
          //   object.name = strings[i]
          //   object.id = i
          //   manstarnum.push(object)
          // }
          self.manstar = res.body.resultList[0];
          // self.manstarnum = manstarnum
        } else {
          self.$toast(res.msg);
        }
      }
    );
    if (window.jump && tool.isMdd()) {
      jump.getUserInfo(function(data) {
        if (data.status == 0) {
          self.markPoint({
            action: "page_show",
            label: -1
          });
        }
        jump.infoCallback(data);
        if (data.status == 0) {
          // 已登陆
          self.userUuid = data.id;
          self.userAvatar = data.iconurl
            ? (data.iconurl = self.setHttps(data.iconurl))
            : "https://activity-1254361794.file.myqcloud.com/outsource/default.png";
          self.nickname = data.nickname;
          self.userInfo = data;
          self.logined = true;
          self.isOut = false;
          self.isWeixin = true;
          const parpam = {
            memberUuid: data.id
          };
          // 获取是否是会员

          getSimpleMemberInfo(parpam).then(res => {
            self.isVodVip = res.data.isVodVip;
            const userbrickparpam = {
              userId: self.userUuid,
              iconUrl: self.userAvatar,
              nickName: self.nickname,
              type: self.isVodVip
            };
            // 星星初始化
            self.$POST(
              "/base/api/heartuser/addToRedis",
              userbrickparpam,
              function(res) {
                if (res.errorCode == 0) {
                  self.userbricknum = res.body.propsNum;
                  self.popUpPromptnum = res.body.dateFormatNum;
                  self.shareSuccessTimes = res.body.shareSuccessTimes;
                  self.popUpPrompt = res.body.popUpPrompt;
                  self.numIcon = [];
                  self.showicon(self.userbricknum);
                  // self.$GET(
                  //   '/base/api/heartuser/findHeartUserByRedis',
                  //   userbrickparpam,
                  //   function (res) {
                  //     if (res.errorCode === 0) {
                  //       self.userbricknum = res.body.propsNum
                  //       self.shareSuccessTimes = res.body.shareSuccessTimes
                  //       self.popUpPromptnum = res.body.dateFormatNum
                  //       self.popUpPrompt = res.body.popUpPrompt
                  //       self.numIcon = []
                  //       self.showicon(self.userbricknum)
                  //     } else {
                  //       self.$toast(res.msg)
                  //     }
                  //   }
                  // )
                } else {
                  self.$toast(res.msg);
                }
              }
            );
          });

          // self.getUser()
        } else {
          const isLogin = localStorage.setItem("isLogin", "false");
          self.isLogin = false;
        }
      });
      const isLogin = localStorage.getItem("isLogin");
      self.isLogin = isLogin;
      // if (isLogin == 'true') {
      //   // self.fetchUserInfo()
      //   self.isActivity()
      // } else {
      //   self.isActivity()
      // }
    } else {
      // self.getshopList('3.9.5')
      // self.tips = '优惠活动仅限在埋堆堆内参与'
      self.isOut = true;
      self.markPoint({
        action: "page_show",
        label: self.shareUserId == "" ? -1 : self.shareUserId
      });
      if (localStorage.getItem("logined")) {
        self.userUuid = localStorage.getItem("userUuid");
        self.nickname = localStorage.getItem("nickname");
        self.isVodVip = localStorage.getItem("isVodVip");
        if (localStorage.getItem("userAvatar") == null) {
          self.userAvatar =
            "https://activity-1254361794.file.myqcloud.com/outsource/default.png";
        } else {
          self.userAvatar = localStorage.getItem("userAvatar");
        }
        self.$GET(
          "/base/api/heartuser/findHeartUserByRedis",
          {
            userId: self.userUuid,
            iconUrl: self.userAvatar,
            nickName: self.nickname,
            type: self.isVodVip,
            inviteeId: self.shareUserId
          },
          function(res) {
            if (res.errorCode === 0) {
              self.userbricknum = res.body.propsNum;
              self.popUpPromptnum = res.body.dateFormatNum;
              self.shareSuccessTimes = res.body.shareSuccessTimes;
              self.popUpPrompt = res.body.popUpPrompt;
              self.numIcon = [];
              self.showicon(self.userbricknum);
            } else {
              self.$toast(res.msg);
            }
          }
        );
        self.nickname = localStorage.getItem("nickname");
        self.isVodVip = localStorage.getItem("isVodVip");
        self.userNum = localStorage.getItem("usermobile");
        self.logined = localStorage.getItem("logined");
        self.isWeixin = false;
      }
    }
  },
  mounted() {
    var self = this;
    var uploadTime = dateToyyyymmdd(new Date(), "YYYY-MM-dd hh:mm:ss");
    // const api = 'https://yx.mddcloud.com.cn/vodactivity/vote/index#/'
    var api = "https://yx.mddcloud.com.cn/vodactivity/awardCeremony/index#/";
    // var api = "http://47.106.221.72:9000/test/index-maiduidui/index.html/";
    if (self.logined) {
      self.desc = "@" + self.nickname + "邀请你参加埋堆堆颁奖典礼";
    } else {
      self.desc = "邀请你参加埋堆堆颁奖典礼";
    }
    const testApi =
      "https://test.api.mddcloud.com.cn/vodactivity/plate/index#/";
    // const matchProd = /^https:\/\/yx\.mddcloud\.com\.cn\/vodactivity/
    const BASE_URL = api;
    self.shareUrl = BASE_URL;
    self.openInstallData = {
      // activityCode: '70',
      // activityUuid: self.vipActivityUuid,
      activityExtend: "实力演员",
      uploadTime: uploadTime
      // jumpSupport: 0,
      // jumpUrl: `mdd://view/jump?jumpType=3&dataUid=${BASE_URL}`
    };
    self.initOpenInstall();
    self.$share({
      title: "和我一起为Ta打榜，瓜分百万现金红包！",
      desc: self.desc,
      link: window.location.href,
      imgUrl: "https://activity-1254361794.file.myqcloud.com/outsource/prize/share.jpg"
    });
  },
  methods: {
    // 获取用户信息 10aefdf17a554cfb9b682266b0c1e8a3
    fetchUserInfo() {
      var self = this;
      if (!self.userUuid) {
        window.jump.login(window.jump.loginCallback);
      }
      // self.getUser()
      self.getActivityInfo();
    },
    showPopup() {
      if (this.isOut === true) {
        this.show = true;
        this.code = "";
      } else {
        jump.login(jump.loginCallback);
      }
    },
    addmore() {
      var self = this;
      self.lbSort = self.lbSort + 1;
      self.$GET(
        "/base/api/heartStarts/getStartRanking",
        { lbSort: self.lbSort, type: self.gender },
        function(res) {
          if (res.errorCode == 0) {
            res.body.resultList.filter(item => {
              var string = String(item.rank).split("");
              var numIcons = [];
              for (var i = 0; i < string.length; i++) {
                const object = {};
                object.name = string[i];
                object.id = i;
                numIcons.push(object);
              }
              item.no = numIcons;
              return item;
            });
            self.episodesList = res.body.resultList;
            self.isOver = res.body.isOver;
            var data = String(res.body.resultList[0].numberOfProps).split("");
            if (data.length >= 5) {
              var nums = res.body.resultList[0].numberOfProps / 1000;
              var parseNum = nums.toFixed(1);
              var result = parseFloat(parseNum) + "k";
              if (self.gender == 0) {
                self.manstarnums = result;
              } else {
                self.womanstarnums = result;
              }

              var strings = String(result).split("");
              for (var i = 0; i < strings.length; i++) {
                if (strings[i] == ".") {
                  strings[i] = "dian";
                }
                const object = {};
                object.name = strings[i];
                object.id = i;
                self.manstarnum.push(object);
              }
            } else {
              if (self.gender == 0) {
                          self.manstarnums =
                            res.body.resultList[0].numberOfProps;
                        } else {
                          self.womanstarnums =
                            res.body.resultList[0].numberOfProps;
                        }
              for (var i = 0; i < data.length; i++) {
                const object = {};
                object.name = data[i];
                object.id = i;
                self.manstarnum.push(object);
              }
            }
            // var manstarnum = []
            // for (var i = 0; i < strings.length; i++) {
            //   const object = {}
            //   object.name = strings[i]
            //   object.id = i
            //   manstarnum.push(object)
            // }
            if (self.gender == 0) {
              self.manstar = res.body.resultList[0];
            } else {
              self.womanstar = res.body.resultList[0];
            }

            // self.manstarnum = manstarnum
          } else {
            self.$toast(res.msg);
          }
        }
      );
    },
    addmores() {
      var self = this;
      self.fanslbSort = self.fanslbSort + 1;
      this.$GET(
        "/base/api/heartuser/getFanRanking",
        { lbSort: self.fanslbSort },
        function(res) {
          if (res.errorCode == 0) {
            res.body.resultList.filter(item => {
              var string = String(item.rank).split("");
              var numIcons = [];
              for (var i = 0; i < string.length; i++) {
                const object = {};
                object.name = string[i];
                object.id = i;
                numIcons.push(object);
              }
              item.rank = numIcons;
              return item;
            });
            self.userList = res.body.resultList;
            self.FanisOver = res.body.isOver;
            // self.womanstar = res.body[0]
          } else {
            self.$toast(res.msg);
          }
        }
      );
    },
    close() {
      if(this.isOut == true){
        window.location.href = "https://lnk0.com/easylink/ELlA5ksc";
      }else{
        mdd.mddFinishWeb();
      }
    },
    appDeepLink(type, uuid) {
      jump.appDeepLink(type, uuid);
    },
    showicon(num) {
      var self = this;
      var string = String(num).split("");
      if (string.length >= 5) {
        var nums = num / 1000;
        var result = nums.toFixed(1);
        var strings = String(result).split("");
        for (var i = 0; i < strings.length; i++) {
          if (strings[i] == ".") {
            strings[i] = "dian";
          }
          // if (i == strings.length - 1) {
          //   strings[i + 1] = 'k'
          // }
          const object = {};
          object.name = strings[i];
          object.id = i;
          self.numIcon.push(object);
        }
      } else {
        for (var i = 0; i < string.length; i++) {
          const object = {};
          object.name = string[i];
          object.id = i;
          self.numIcon.push(object);
        }
      }
    },
    showdetails(id) {
      var self = this;
      this.$GET(
        "/base/api/leaderboard/listByAll",
        { startId: id, page: 0, size: 20 },
        function(res) {
          if (res.errorCode === 0) {
            self.leaderboard = res.body;
            self.Detailshow = true;
          } else {
            self.$toast(res.msg);
          }
        }
      );
    },
    hidedetails() {
      this.Detailshow = false;
    },
    showbuyModal() {
      this.markPoint({
        action: "item_buy_click",
        label: "-1"
      });
      if (tool.isMdd()) {
        this.buyModalshow = true;
      } else {
        this.outshow = true;
      }
    },
    hidebuyModal() {
      this.buyModalshow = false;
    },
    showConfirmPopup(sort, id, type) {
      // this.confirmPopupShow = true
      var self = this;
      self.giveId = sort;
      if (type == "star") {
        self.startId = id;
        self.typestatus = true;
      } else if (type == "TV") {
        self.episodesId = id;
        self.typestatus = false;
      }
      if (self.logined) {
        if (self.userbricknum == 0) {
          self.markPoint({
            action: "send_heart_click",
            label: sort
          });
          if (tool.isMdd()) {
            self.buyModalshow = true;
          } else {
            self.outshow = true;
          }
        } else {
          self.confirmPopupShow = true;
          self.markPoint({
            action: "send_heart_click",
            label: sort
          });
        }
      } else {
        self.$toast("请先登录");
      }
    },
    hideConfirmPopup() {
      this.confirmPopupShow = false;
    },
    showRules() {
      this.rulesShow = true;
    },
    hideRules() {
      this.rulesShow = false;
    },
    hidebuyStatusshow() {
      this.buyStatusshow = false;
    },
    hideBulletframe() {
      this.popUpPrompt = false;
    },
    confirmBuy() {
      this.buyStatusshow = false;
      this.findUserBrick();
    },
    onSubmit(values) {
      var self = this;
      const data = {
        num: self.moblie,
        code: self.code
      };
      getActivityWebLogin(data)
        .then(res => {
          if (res.msgType === 0) {
            self.userUuid = res.data.uuid;
            if (res.data.headimgurl) {
              self.userAvatar = res.data.headimgurl;
            } else {
              res.data.headimgurl =
                "https://activity-1254361794.file.myqcloud.com/outsource/default.png";
            }
            self.nickname = res.data.nickName;
            self.isVodVip = res.data.isVodVip;
            self.userNum = res.data.num;
            localStorage.setItem("userUuid", res.data.uuid);
            localStorage.setItem("userAvatar", res.data.headimgurl);
            localStorage.setItem("nickname", res.data.nickName);
            localStorage.setItem("isVodVip", res.data.isVodVip);
            localStorage.setItem("usermobile", res.data.num);
            localStorage.setItem("logined", true);
            const userbrickparpam = {
              userId: res.data.uuid,
              iconUrl: res.data.headimgurl,
              nickName: res.data.nickName,
              type: res.data.isVodVip,
              inviteeId: self.shareUserId
            };
            self.$POST(
              "/base/api/heartuser/addToRedis",
              userbrickparpam,
              function(res) {
                if (res.errorCode === 0) {
                  self.userbricknum = res.body.propsNum;
                  self.popUpPromptnum = res.body.dateFormatNum;
                  self.shareSuccessTimes = res.body.shareSuccessTimes;
                  self.popUpPrompt = res.body.popUpPrompt;
                  self.numIcon = [];
                  self.showicon(self.userbricknum);
                } else {
                  self.$toast(res.msg);
                }
              }
            );
            self.show = false;
            self.logined = true;
            self.$toast("登录成功");
            localStorage.setItem("isLogin", "true");
          } else {
            self.$toast(res.msg);
            localStorage.setItem("isLogin", "false");
          }
        })
        .catch(err => {
          localStorage.setItem("isLogin", "false");
        });
    },
    loginOut() {
      if (this.isOut && this.logined) {
        this.loginoutshow = true;
      }
    },
    hideloginoutshow() {
      this.loginoutshow = false;
    },
    confirmLogin() {
      var self = this;
      this.logined = false;
      this.loginoutshow = false;
      this.userAvatar =
        "https://activity-1254361794.file.myqcloud.com/outsource/default.png";
      localStorage.removeItem("userUuid");
      localStorage.removeItem("userAvatar");
      localStorage.removeItem("nickname");
      localStorage.removeItem("isVodVip");
      localStorage.removeItem("usermobile");
      localStorage.removeItem("logined");
      self.$toast("退出成功");
    },
    sendcode() {
      var self = this;
      var reg = 11 && /^((13|14|15|17|18)[0-9]{1}\d{8})$/;
      if (this.moblie == "") {
        self.$toast("手机号不能为空");
      } else if (!reg.test(this.moblie)) {
        self.$toast("手机号格式不正确");
      } else if (this.disabled == true) {
        self.$toast("请稍后重试");
      } else {
        this.time = 60;
        this.disabled = true;
        // 验证码的时间设置 可有可无
        this.timer();
        const data = {
          num: this.moblie
        };
        // 手机号获取后调取接口
        getActivityWebCode(data).then(res => {
          if (res.msgType === 0) {
            self.$toast("获取成功,请注意查收验证码");
          } else {
            self.$toast(res.msg);
          }
        });
      }
    },
    mddlink() {
      var self = this
      this.markPoint({
        action: "download_click",
        label: self.shareUserId == "" ? -1 : self.shareUserId
      });
      window.location.href = " https://lnk0.com/easylink/ELlA5ksc";
    },
    // 验证码的倒计时
    timer() {
      if (this.time > 0) {
        this.time--;
        this.btntxt = "重新获取" + this.time + "s";
        setTimeout(this.timer, 1000);
      } else {
        this.time = 0;
        this.btntxt = "获取验证码";
        this.disabled = false;
      }
    },
    select(n) {
      if (this.userbricknum < 5 && n == 5) {
      } else {
        this.selectActive = n;
        this.brickNumber = n;
      }
    },
    delivery() {
      var self = this;
      const timestamp = new Date().getTime();
      const andTime = 1610208000000;
      if (timestamp > andTime) {
        self.dateshow = true;
        self.tips = "活动已结束";
        return
      }
      if (self.typestatus) {
        if (self.isclick) {
          self.isclick = false;
          const userbrickparpam = {
            startId: self.startId,
            heartNumber: self.brickNumber,
            userId: self.userUuid,
            iconUrl: self.userAvatar,
            nickName: self.nickname,
            type: self.isVodVip
          };
          self.$POST(
            "base/api/heartStarts/vote/startHeartToRedis",
            userbrickparpam,
            function(res) {
              if (res.errorCode === 0) {
                self.confirmPopupShow = false;

                self.$toast("成功送出心心X" + self.brickNumber);
                self.$GET(
                  "/base/api/heartuser/findHeartUserByRedis",
                  {
                    userId: self.userUuid,
                    iconUrl: self.userAvatar,
                    nickName: self.nickname,
                    type: self.isVodVip
                  },
                  function(res) {
                    if (res.errorCode === 0) {
                      self.userbricknum = res.body.propsNum;
                      self.popUpPromptnum = res.body.dateFormatNum;
                      self.popUpPrompt = res.body.popUpPrompt;
                      self.shareSuccessTimes = res.body.shareSuccessTimes;
                      self.numIcon = [];
                      self.showicon(self.userbricknum);
                    } else {
                      self.$toast(res.msg);
                    }
                  }
                );

                self.$GET(
                  "/base/api/heartStarts/getStartRanking",
                  { lbSort: self.lbSort, type: self.gender },
                  function(res) {
                    if (res.errorCode == 0) {
                      res.body.resultList.filter(item => {
                        var string = String(item.rank).split("");
                        var numIcons = [];
                        for (var i = 0; i < string.length; i++) {
                          const object = {};
                          object.name = string[i];
                          object.id = i;
                          numIcons.push(object);
                        }
                        item.no = numIcons;
                        return item;
                      });
                      self.episodesList = res.body.resultList;
                      var data = String(
                        res.body.resultList[0].numberOfProps
                      ).split("");
                      if (data.length >= 5) {
                        var nums = res.body.resultList[0].numberOfProps / 1000;
                        var parseNum = nums.toFixed(1);
                        var result = parseFloat(parseNum) + "k";
                        if (self.gender == 0) {
                          self.manstarnums = result;
                        } else {
                          self.womanstarnums = result;
                        }
                        var strings = String(result).split("");
                        for (var i = 0; i < strings.length; i++) {
                          if (strings[i] == ".") {
                            strings[i] = "dian";
                          }
                          const object = {};
                          object.name = strings[i];
                          object.id = i;
                          self.manstarnum.push(object);
                        }
                      } else {
                        if (self.gender == 0) {
                          self.manstarnums =
                            res.body.resultList[0].numberOfProps;
                        } else {
                          self.womanstarnums =
                            res.body.resultList[0].numberOfProps;
                        }
                        for (var i = 0; i < data.length; i++) {
                          const object = {};
                          object.name = data[i];
                          object.id = i;
                          self.manstarnum.push(object);
                        }
                      }
                      // var manstarnum = []
                      // for (var i = 0; i < strings.length; i++) {
                      //   const object = {}
                      //   object.name = strings[i]
                      //   object.id = i
                      //   manstarnum.push(object)
                      // }
                      if (self.gender == 0) {
              self.manstar = res.body.resultList[0];
            } else {
              self.womanstar = res.body.resultList[0];
            }

                      // self.manstarnum = manstarnum
                    } else {
                      self.$toast(res.msg);
                    }
                  }
                );
              } else {
                self.$toast(res.msg);
              }
            }
          );
          self.markPoint({
            action: "send_heart_finish",
            label: self.giveId + "," + self.brickNumber
          });
          setTimeout(function() {
            self.isclick = true;
          }, 1000);
        }
      } else {
        if (self.isclick) {
          self.isclick = false;
          const userbrickparpams = {
            episodesId: self.episodesId,
            heartNumber: self.brickNumber,
            userId: self.userUuid,
            iconUrl: self.userAvatar,
            nickName: self.nickname,
            type: self.isVodVip
          };
          self.$POST(
            "/base/api/heartEpisodes/vote/voteEpisodesToRedis",
            userbrickparpams,
            function(res) {
              if (res.errorCode === 0) {
                self.confirmPopupShow = false;

                self.$toast("成功送出心心X" + self.brickNumber);
                self.$GET(
                  "/base/api/heartuser/findHeartUserByRedis",
                  {
                    userId: self.userUuid,
                    iconUrl: self.userAvatar,
                    nickName: self.nickname,
                    type: self.isVodVip
                  },
                  function(res) {
                    if (res.errorCode === 0) {
                      self.userbricknum = res.body.propsNum;
                      self.popUpPromptnum = res.body.dateFormatNum;
                      self.popUpPrompt = res.body.popUpPrompt;
                      self.shareSuccessTimes = res.body.shareSuccessTimes;
                      self.numIcon = [];
                      self.showicon(self.userbricknum);
                    } else {
                      self.$toast(res.msg);
                    }
                  }
                );
                self.$GET(
                  "/base/api/heartEpisodes/getEpisodesRanking",
                  { lbSort: 1 },
                  function(res) {
                    if (res.errorCode == 0) {
                      self.TVList = res.body.resultList;
                    } else {
                      self.$toast(res.msg);
                    }
                  }
                );
              } else {
                self.$toast(res.msg);
              }
            }
          );
          self.markPoint({
            action: "send_heart_finish",
            label: self.giveId + "," + self.brickNumber
          });
          setTimeout(function() {
            self.isclick = true;
          }, 1000);
        }
      }
    },
    mddVipRecharge(type) {
      var self = this;
      const payChannelList = [
        { channelName: "微信支付", channelCode: "0", promoteIcon: "" },
        { channelName: "支付宝支付", channelCode: "1", promoteIcon: "" },
        { channelName: "堆币支付", channelCode: "10", promoteIcon: "" },
        { channelName: "银联支付", channelCode: "11", promoteIcon: "" }
      ];
      const payChannelLists = [
        { channelName: "微信支付", channelCode: "0", promoteIcon: "" },
        { channelName: "支付宝支付", channelCode: "1", promoteIcon: "" },
        { channelName: "银联支付", channelCode: "11", promoteIcon: "" }
      ];
      const payChannelListIOS = [
        { channelName: "ios支付", channelCode: "2", promoteIcon: "" },
        { channelName: "堆币支付", channelCode: "10", promoteIcon: "" }
      ];
      const payChannelListsIOS = [
        { channelName: "ios支付", channelCode: "2", promoteIcon: "" }
      ];
      if (type == 1) {
         self.markPoint({
            action: "item_pay_click",
            label: 10
          });
        const parpam = {
          h5PayType: 1,
          activityUuid: "",
          goodUuid: "77ba2c2245be11ebbb89f02fa73bc0f4",
          goodName: "10心心",
          totalPayPrice: "1.00",
          channelNum: "77",
          payChannelList: tool.isAndroid()
            ? payChannelLists
            : payChannelListsIOS
        };
        jump.mddVipRecharge(parpam);
        self.buyModalshow = false;
        self.buyStatusshow = true;
      } else if (type == 12) {
        self.markPoint({
            action: "item_pay_click",
            label: 120
          });
        const parpam = {
          h5PayType: 1,
          activityUuid: "",
          goodUuid: "16b759d645bc11ebbb89f02fa73bc0f4",
          goodName: "120心心",
          totalPayPrice: "12.00",
          channelNum: "77",
          duibPrice: "120",
          payChannelList: tool.isAndroid() ? payChannelList : payChannelListIOS
        };
        jump.mddVipRecharge(parpam);
        self.buyModalshow = false;
        self.buyStatusshow = true;
      } else if (type == 40) {
        self.markPoint({
            action: "item_pay_click",
            label: 400
          });
        const parpam = {
          h5PayType: 1,
          activityUuid: "",
          goodUuid: "b1273ba645bc11ebbb89f02fa73bc0f4",
          goodName: "400心心",
          totalPayPrice: "40.00",
          channelNum: "77",
          duibPrice: "400",
          payChannelList: tool.isAndroid() ? payChannelList : payChannelListIOS
        };
        jump.mddVipRecharge(parpam);
        self.buyModalshow = false;
        self.buyStatusshow = true;
      } else if (type == 118) {
        self.markPoint({
            action: "item_pay_click",
            label: 1180
          });
        const parpam = {
          h5PayType: 1,
          activityUuid: "",
          goodUuid: "e0925f3345bc11ebbb89f02fa73bc0f4",
          goodName: "1180心心",
          totalPayPrice: "118.00",
          channelNum: "77",
          duibPrice: "1180",
          payChannelList: tool.isAndroid() ? payChannelList : payChannelListIOS
        };
        jump.mddVipRecharge(parpam);
        self.buyModalshow = false;
        self.buyStatusshow = true;
      }
    },
    // getUser () {
    //   var self = this
    //   getSimpleMemberInfo({
    //     memberUuid: self.userUuid
    //   })
    //     .then(res => {
    //       if (res.status && res.msgType === 0) {
    //         res.data.headimgurl
    //           ? (res.data.headimgurl = self.setHttps(res.data.headimgurl))
    //           : (res.data.headimgurl =
    //               '//post-1254361794.file.myqcloud.com/homepage/avatar.png')
    //         res.data.effectEndTime
    //           ? (res.data.effectEndTime = res.data.effectEndTime.slice(0, 10))
    //           : ''
    //         self.userInfo = res.data
    //         self.isLogin = true
    //         localStorage.setItem('isLogin', 'true')
    //       } else {
    //         self.isLogin = false
    //         localStorage.setItem('isLogin', 'false')
    //       }
    //     })
    //     .catch(err => {
    //       self.isLogin = false
    //       localStorage.setItem('isLogin', 'false')
    //     })
    // },
    close() {
      jump.mddFinishWeb();
    },
    showEpisodes() {
      var self = this;
      this.esStatus = true;
      self.$GET(
        "/base/api/heartEpisodes/getEpisodesRanking",
        { lbSort: 1 },
        function(res) {
          if (res.errorCode == 0) {
            self.TVList = res.body.resultList;
          } else {
            self.$toast(res.msg);
          }
        }
      );
    },
    showFans() {
      var self = this;
      this.esStatus = false;
      this.$GET("/base/api/heartuser/getFanRanking", { lbSort: 1 }, function(
        res
      ) {
        if (res.errorCode == 0) {
          res.body.resultList.filter(item => {
            var string = String(item.rank).split("");
            var numIcons = [];
            for (var i = 0; i < string.length; i++) {
              const object = {};
              object.name = string[i];
              object.id = i;
              numIcons.push(object);
            }
            item.rank = numIcons;
            return item;
          });
          self.userList = res.body.resultList;
          self.FanisOver = res.body.isOver;
          // self.womanstar = res.body[0]
        } else {
          self.$toast(res.msg);
        }
      });
    },
    showmalecelebrity() {
      var self = this;
      this.starActive = true;
      self.gender = 0;
      this.$GET(
        "/base/api/heartStarts/getStartRanking",
        { lbSort: 1, type: self.gender },
        function(res) {
          if (res.errorCode == 0) {
            res.body.resultList.filter(item => {
              var string = String(item.rank).split("");
              var numIcons = [];
              for (var i = 0; i < string.length; i++) {
                const object = {};
                object.name = string[i];
                object.id = i;
                numIcons.push(object);
              }
              item.no = numIcons;
              return item;
            });
            self.episodesList = res.body.resultList;
            var data = String(res.body.resultList[0].numberOfProps).split("");
            if (data.length >= 5) {
              var nums = res.body.resultList[0].numberOfProps / 1000;
              var parseNum = nums.toFixed(1);
              var result = parseFloat(parseNum) + "k";
              if (self.gender == 0) {
                self.manstarnums = result;
              } else {
                self.womanstarnums = result;
              }
              var strings = String(result).split("");
              for (var i = 0; i < strings.length; i++) {
                if (strings[i] == ".") {
                  strings[i] = "dian";
                }
                const object = {};
                object.name = strings[i];
                object.id = i;
                self.manstarnum.push(object);
              }
            } else {
              if (self.gender == 0) {
                          self.manstarnums =
                            res.body.resultList[0].numberOfProps;
                        } else {
                          self.womanstarnums =
                            res.body.resultList[0].numberOfProps;
                        }
              for (var i = 0; i < data.length; i++) {
                const object = {};
                object.name = data[i];
                object.id = i;
                self.manstarnum.push(object);
              }
            }
            // var manstarnum = []
            // for (var i = 0; i < strings.length; i++) {
            //   const object = {}
            //   object.name = strings[i]
            //   object.id = i
            //   manstarnum.push(object)
            // }
            if (self.gender == 0) {
              self.manstar = res.body.resultList[0];
            } else {
              self.womanstar = res.body.resultList[0];
            }
            self.isOver = res.body.isOver;
          } else {
            self.$toast(res.msg);
          }
        }
      );
    },
    showmalecelebritys() {
      var self = this;
      this.starActive = false;
      self.gender = 1;
      this.$GET(
        "/base/api/heartStarts/getStartRanking",
        { lbSort: 1, type: self.gender },
        function(res) {
          if (res.errorCode == 0) {
            res.body.resultList.filter(item => {
              var string = String(item.rank).split("");
              var numIcons = [];
              for (var i = 0; i < string.length; i++) {
                const object = {};
                object.name = string[i];
                object.id = i;
                numIcons.push(object);
              }
              item.no = numIcons;
              return item;
            });
            self.episodesList = res.body.resultList;
            var data = String(res.body.resultList[0].numberOfProps).split("");
            if (data.length >= 5) {
              var nums = res.body.resultList[0].numberOfProps / 1000;
              var parseNum = nums.toFixed(1);
              var result = parseFloat(parseNum) + "k";
              if (self.gender == 0) {
                self.manstarnums = result;
              } else {
                self.womanstarnums = result;
              }
              var strings = String(result).split("");
              for (var i = 0; i < strings.length; i++) {
                if (strings[i] == ".") {
                  strings[i] = "dian";
                }
                const object = {};
                object.name = strings[i];
                object.id = i;
                self.manstarnum.push(object);
              }
            } else {
              if (self.gender == 0) {
                          self.manstarnums =
                            res.body.resultList[0].numberOfProps;
                        } else {
                          self.womanstarnums =
                            res.body.resultList[0].numberOfProps;
                        }
              for (var i = 0; i < data.length; i++) {
                const object = {};
                object.name = data[i];
                object.id = i;
                self.manstarnum.push(object);
              }
            }
            // var manstarnum = []
            // for (var i = 0; i < strings.length; i++) {
            //   const object = {}
            //   object.name = strings[i]
            //   object.id = i
            //   manstarnum.push(object)
            // }
            if (self.gender == 0) {
              self.manstar = res.body.resultList[0];
            } else {
              self.womanstar = res.body.resultList[0];
            }
            self.isOver = res.body.isOver;
          } else {
            self.$toast(res.msg);
          }
        }
      );
    },
    findUserBrick() {
      var self = this;
      const userbrickparpam = {
        userId: self.userUuid,
        iconUrl: self.userAvatar,
        nickName: self.nickname,
        type: self.isVodVip
      };
      // alert('调用了')
      self.$GET(
        "/base/api/heartuser/findHeartUserByRedis",
        userbrickparpam,
        function(res) {
          if (res.errorCode === 0) {
            self.userbricknum = res.body.propsNum;
            self.popUpPromptnum = res.body.dateFormatNum;
            self.shareSuccessTimes = res.body.shareSuccessTimes;
            self.popUpPrompt = res.body.popUpPrompt;
            self.numIcon = [];
            self.showicon(self.userbricknum);
          } else {
            self.$toast(res.msg);
          }
        }
      );
    },
    success() {
      window.location.reload();
    },
    copyToClip(content, message) {
      var self = this;
      var aux = document.createElement("input");
      aux.setAttribute("value", content);
      document.body.appendChild(aux);
      aux.select();
      document.execCommand("copy");
      document.body.removeChild(aux);
      if (message == null) {
        self.$toast("复制成功");
      } else {
        self.$toast(message);
      }
    },
    setHttps: function(val) {
      val = val.split(":");
      const img =
        val[0].toLowerCase() === "http"
          ? `${val[0]}s:${val[1]}`
          : `${val[0]}:${val[1]}`;
      return img;
    },
    appshare() {
      const self = this;
      self.markPoint({
        action: "share_click",
        label: -1
      });
      var url = self.shareUrl + "?userId=" + self.userUuid;
      if (self.logined) {
        self.desc = "@" + self.nickname + "邀请你参加埋堆堆颁奖典礼";
      } else {
        self.desc = "邀请你参加埋堆堆颁奖典礼";
      }
      if (tool.isWeixin()) {
        self.Detailshow = true;
      } else if (!tool.isWeixin() && !tool.isMdd()) {
        self.copyToClip(
          window.location.href,
          "已复制链接，快分享给你的好友吧"
        );
      } else if (tool.isMdd()) {
        if (tool.isAndroid()) {
          app.mddShare(
            JSON.stringify({
              iconUrl: "https://activity-1254361794.file.myqcloud.com/outsource/prize/share.jpg",
              title: "和我一起为Ta打榜，瓜分百万现金红包！",
              desc: self.desc,
              webUrl: url
            })
          );
        } else if (tool.isiOS()) {
          if (window.webkit) {
            window.webkit.messageHandlers.mddShare.postMessage({
              iconUrl: "https://activity-1254361794.file.myqcloud.com/outsource/prize/share.jpg",
              title: "和我一起为Ta打榜，瓜分百万现金红包！",
              desc: self.desc,
              webUrl: url
            });
          } else {
            mddShare({
              iconUrl: "https://activity-1254361794.file.myqcloud.com/outsource/prize/share.jpg",
              title: "和我一起为Ta打榜，瓜分百万现金红包！",
              desc: self.desc,
              webUrl: url
            });
          }
        }
      }
      if (self.shareClick == false && self.isOut == false) {
        self.shareClick = true;
        setTimeout(function() {
          self.$POST(
            "/base/api/heartuser/shareToGetProps",
            { userId: self.userUuid },
            function(res) {
              if (res.errorCode == 0) {
                self.shareClick = false;
                self.$GET(
                  "/base/api/heartuser/findHeartUserByRedis",
                  {
                    userId: self.userUuid,
                    iconUrl: self.userAvatar,
                    nickName: self.nickname,
                    type: self.isVodVip
                  },
                  function(res) {
                    if (res.errorCode === 0) {
                      self.userbricknum = res.body.propsNum;
                      self.popUpPromptnum = res.body.dateFormatNum;
                      self.popUpPrompt = res.body.popUpPrompt;
                      self.shareSuccessTimes = res.body.shareSuccessTimes;
                      self.numIcon = [];
                      self.showicon(self.userbricknum);
                    } else {
                      self.$toast(res.msg);
                    }
                  }
                );
              } else {
                self.$toast(res.msg);
              }
            }
          );
        }, 2000);
      }
    },
    share() {
      const self = this;
      if (tool.isWeixin()) {
        self.Detailshow = true;
      } else if (!tool.isWeixin() && !tool.isMdd()) {
        self.copyToClip(
          "https://yx.mddcloud.com.cn/vodactivity/vote/index#/",
          "已复制链接，快分享给你的好友吧"
        );
      } else if (tool.isMdd()) {
        if (tool.isAndroid()) {
          app.mddShare(
            JSON.stringify({
              iconUrl: "https://activity-1254361794.file.myqcloud.com/outsource/prize/share.jpg",
              title: "快帮我投票",
              desc: "一起来支持喜欢的演员吧！",
              webUrl: self.shareUrl
            })
          );
        } else if (tool.isiOS()) {
          if (window.webkit) {
            window.webkit.messageHandlers.mddShare.postMessage({
              iconUrl: "https://activity-1254361794.file.myqcloud.com/outsource/prize/share.jpg",
              title: "快帮我投票",
              desc: "一起来支持喜欢的演员吧！",
              webUrl: self.shareUrl
            });
          } else {
            mddShare({
              iconUrl: "https://activity-1254361794.file.myqcloud.com/outsource/prize/share.jpg",
              title: "快帮我投票",
              desc: "一起来支持喜欢的演员吧！",
              webUrl: self.shareUrl
            });
          }
        }
      }
    },
    openinstall() {
      var self = this;
      // //埋点
      // self.markPoint({
      // 	action: 'share_receive_click'
      // })
      self.openInstallObj.schemeWakeup();
      self.openInstallObj.wakeupOrInstall();
    },
    // 埋点
    markPoint({ action, label }) {
      var self = this;
      var statSigndata = {
        game_id: 81,
        action: action,
        label: label,
        page: "awards_ceremony_page",
        channel: "-1"
      };
      window.tool.getstatSign(statSigndata);
    },
    // 判断活动是否开始
    isActivity: function() {
      const self = this;
      try {
        jump.mddGetVersionName(jump.VersionName);
      } catch (err) {
        self.isVersionNameShow = true;
        return;
      }
      self.isVersionName = localStorage.getItem("VersionName");
    },
    // 协议页面跳转
    // 协议页面跳转
    goto: function(type) {
      const self = this;
      if (type == 1) {
        window.jump.newweb(
          "http://yx.mddcloud.com.cn/vodactivity/newvip/membershipAgreement.html"
        );
      } else if (type == 2) {
        window.jump.newweb(
          "http://yx.mddcloud.com.cn/vodactivity/newvip/faq.html"
        );
      } else if (type == 3) {
        window.jump.newweb(
          "https://kefu.easemob.com/webim/im.html?configId=068de2ad-5caa-4fb3-89a6-21b465b960d0"
        );
      }
    }
  }
};
</script>

<style scoped lang='less'>
.main_pages {
  width: 100%;
  // height: 2316px;
  padding-bottom: 116px;
  height: auto;
  box-sizing: border-box;
  font-family: PingFangSC-Regular, PingFang SC;
  // background-image: url("https://activity-1254361794.file.myqcloud.com/outsource/prize/bg-header.png"),url("https://activity-1254361794.file.myqcloud.com/outsource/prize/bg-1.png"),url("https://activity-1254361794.file.myqcloud.com/outsource/prize/bg-2.png"),
  //                    url("https://activity-1254361794.file.myqcloud.com/outsource/prize/bg-3.png");
  display: block;
  background: url("https://activity-1254361794.file.myqcloud.com/outsource/prize/bg-header.png") 0 0 no-repeat,
    url("https://activity-1254361794.file.myqcloud.com/outsource/prize/bg-1.png") 0 363px no-repeat,
    url("https://activity-1254361794.file.myqcloud.com/outsource/prize/bg-2.png") 0 727px no-repeat,
    url("https://activity-1254361794.file.myqcloud.com/outsource/prize/bg-3.png") 0 1090px no-repeat,
    url("https://activity-1254361794.file.myqcloud.com/outsource/prize/bg-1.png") 0 1453px no-repeat,
    url("https://activity-1254361794.file.myqcloud.com/outsource/prize/bg-2.png") 0 1816px no-repeat,
    url("https://activity-1254361794.file.myqcloud.com/outsource/prize/bg-3.png") 0 2179px no-repeat,
    url("https://activity-1254361794.file.myqcloud.com/outsource/prize/bg-1.png") 0 2542px no-repeat,
    url("https://activity-1254361794.file.myqcloud.com/outsource/prize/bg-2.png") 0 2905px no-repeat,
    url("https://activity-1254361794.file.myqcloud.com/outsource/prize/bg-3.png") 0 3268px no-repeat,
    url("https://activity-1254361794.file.myqcloud.com/outsource/prize/bg-1.png") 0 3631px no-repeat,
    url("https://activity-1254361794.file.myqcloud.com/outsource/prize/bg-2.png") 0 3994px no-repeat,
    url("https://activity-1254361794.file.myqcloud.com/outsource/prize/bg-3.png") 0 4357px no-repeat,
    url("https://activity-1254361794.file.myqcloud.com/outsource/prize/bg-1.png") 0 4720px no-repeat,
    url("https://activity-1254361794.file.myqcloud.com/outsource/prize/bg-2.png") 0 5083px no-repeat,
    url("https://activity-1254361794.file.myqcloud.com/outsource/prize/bg-3.png") 0 5446px no-repeat,
    url("https://activity-1254361794.file.myqcloud.com/outsource/prize/bg-1.png") 0 5809px no-repeat,
    url("https://activity-1254361794.file.myqcloud.com/outsource/prize/bg-2.png") 0 6172px no-repeat,
    url("https://activity-1254361794.file.myqcloud.com/outsource/prize/bg-3.png") 0 6535px no-repeat,
    url("https://activity-1254361794.file.myqcloud.com/outsource/prize/bg-1.png") 0 6898px no-repeat,
    url("https://activity-1254361794.file.myqcloud.com/outsource/prize/bg-2.png") 0 7261px no-repeat,
    url("https://activity-1254361794.file.myqcloud.com/outsource/prize/bg-3.png") 0 7624px no-repeat,
    url("https://activity-1254361794.file.myqcloud.com/outsource/prize/bg-1.png") 0 7987px no-repeat,
    url("https://activity-1254361794.file.myqcloud.com/outsource/prize/bg-2.png") 0 8350px no-repeat,
    url("https://activity-1254361794.file.myqcloud.com/outsource/prize/bg-3.png") 0 8713px no-repeat,
    url("https://activity-1254361794.file.myqcloud.com/outsource/prize/bg-1.png") 0 9076px no-repeat,
    url("https://activity-1254361794.file.myqcloud.com/outsource/prize/bg-2.png") 0 9439px no-repeat,
    url("https://activity-1254361794.file.myqcloud.com/outsource/prize/bg-3.png") 0 9802px no-repeat,
    url("https://activity-1254361794.file.myqcloud.com/outsource/prize/bg-1.png") 0 10165px no-repeat,
    url("https://activity-1254361794.file.myqcloud.com/outsource/prize/bg-2.png") 0 10528px no-repeat,
    url("https://activity-1254361794.file.myqcloud.com/outsource/prize/bg-3.png") 0 10891px no-repeat;
  background-size: 100% auto;
  position: relative;
}
.share {
  background: url("https://activity-1254361794.file.myqcloud.com/outsource/vote/share.png");
  background-size: 100% auto;
  width: 18px;
  height: 18px;
  position: absolute;
  top: 15px;
  right: 13px;
}
.activityRules {
  background: url("https://activity-1254361794.file.myqcloud.com/outsource/prize/rule.png");
  background-size: 100% auto;
  width: 27px;
  height: 70px;
  position: absolute;
  top: 64px;
  right: 0px;
}
.ActivityAwardbox {
  padding-top: 282px;
  width: 120px;
  height: 43px;
}
.ActivityAward {
  width: 120px;
  height: 43px;
  margin-left: 11px;
}
.Celebrityrankingbox {
  margin-top: 25px;
  width: 120px;
  height: 43px;
}
.Awardcoverbox {
  overflow: hidden;
  height: 126px;
  margin-top: 9px;
}
.scroller {
  white-space: nowrap; /*文本不会换行，文本会在在同一行上继续*/
  overflow-x: auto; /*可滑动*/
  // height: 159px;
}
::-webkit-scrollbar {
  display: none;
}
.cover {
  width: 113px;
  display: inline-block;
  position: relative;
  height: 126px;
  margin-left: 7px;
  // background-color: #FFFFFF;
}
.banner {
  width: 100%;
  height: 100%;
}
.cover:last-child {
  margin-right: 4px;
}
.cover:first-child {
  margin-left: 11px;
}
.cover-title {
  width: 114px;
  line-height: 17px;
  text-align: center;
  white-space: nowrap;
  color: #aa4da9;
  font-size: 12px;
  position: absolute;
  top: 135px;
  left: 0;
  z-index: 999;
}
.Topbox {
  height: 81px;
  width: 100%;
  // background-color: #fff;
  // transform:translateY(-2px);
  margin-top: 9px;
  display: flex;
  flex-direction: row;
  position: relative;
}
.Maleleader {
  display: flex;
  flex-direction: row;
  width: auto;
  height: 81px;
}
.Maleleader_avatar {
  width: 81px;
  height: 81px;
  box-sizing: border-box;
  margin-left: 18px;
  border-radius: 50%;
  border: 2px solid #927e5f;
  position: relative;
  overflow: hidden;
}
.Femaletop_avatar {
  width: 81px;
  height: 81px;
  box-sizing: border-box;
  margin-left: auto;
  overflow: hidden;
  // margin-right: 18px;
  border-radius: 50%;
  border: 2px solid #927e5f;

  position: relative;
  position: absolute;
  top: 0;
  right: 18px;
}
.IconLeft {
  transform: translateX(-5px);
}
.mantop {
  width: 31px;
  height: 18px;
  background: linear-gradient(to bottom, #beab4c, #b79200);
  border-radius: 5px;
  color: #ffffff;
  font-size: 11px;
  display: flex;
  justify-content: center;
  align-items: center;
  font-weight: 600;
  // line-height: 24px;
  position: absolute;
  top: -14px;
  z-index: 466666;
  left: 23px;
}
.womantop {
  width: 31px;
  height: 18px;
  background: linear-gradient(to bottom, #beab4c, #b79200);
  border-radius: 5px;
  color: #ffffff;
  font-size: 11px;
  display: flex;
  justify-content: center;
  align-items: center;
  font-weight: 600;
  line-height: 16px;
  position: absolute;
  top: -14px;
  z-index: 466666;
  right: 23px;
}
.top1 {
  width: 71px;
  height: 18px;
  background: linear-gradient(to bottom, #ff98b1, #ff5b5b);
  border-radius: 70px;
  color: #ffffff;
  font-size: 10px;
  display: flex;
  justify-content: center;
  align-items: center;
  line-height: 16px;
  position: absolute;
  top: 68px;
  z-index: 466666;
  left: 5px;
}
.starsInfo {
  width: auto;
  height: 81px;
}
.Femaletop_name {
  color: #ebebeb;
  font-size: 18px;
  line-height: 25px;
  margin-top: 22px;
  font-weight: bold;
  position: relative;
}
.Femaletop_name_line {
  width: 49px;
  height: 4px;
  border-radius: 81px;
  background-color: #262626;
  position: absolute;
  left: 0;
  top: 23px;
}
.name {
  color: #ebebeb;
  text-align: center;
  font-size: 18px;
  line-height: 25px;
  margin-top: 22px;
  margin-left: 20px;
  font-weight: bold;
  position: relative;
}
.name_line {
  width: 49px;
  height: 4px;
  border-radius: 81px;
  background-color: #262626;
  position: absolute;
  right: 1px;
  top: 23px;
}
.xinnumber {
  color: #bea04c;
  font-size: 14px;
  line-height: 20px;
}
.star {
  display: flex;
  margin-left: 3px;
  flex-direction: row;
  align-items: center;
  justify-content: flex-end;
  width: auto;
  height: 17px;
  margin-top: 5px;
}
.Femaletop_star {
  display: flex;
  flex-direction: row;
  align-items: center;
  width: auto;
  height: 17px;
  margin-top: 5px;
}
.starsnums {
  width: 8px;
  height: 8px;
  margin-top: 9px;
}
.starss {
  width: 17px;
  height: 17px;
  margin-right: 2px;
}
.Icon {
  width: 9px;
  height: 14px;
  position: relative;
  top: 2px;
}
.dians {
  width: 4px;
  height: 4px;
  position: relative;
}
.starnum {
  width: 14px;
  height: 14px;
  position: absolute;
  top: 0;
  left: -3px;
}
.starnums {
  width: 14px;
  height: 14px;
  position: absolute;
  top: 0;
  left: -2px;
}
.dian {
  width: 4px;
  height: 4px;
  position: absolute;
  top: 5px;
  left: -1px;
}
.starsK {
  width: 14px;
  height: 14px;
  position: absolute;
  top: 0;
  left: 14px;
}
.Femaletop {
  margin-left: 23px;
  display: flex;
  flex-direction: row;
  width: auto;
  height: 81px;
}
.Dividingline {
  width: 100%;
  height: 4px;
  // background-color: #C4C4C4;
  position: relative;
  z-index: 1;
  margin-top: 2px;
}
.white {
  width: 185px;
  height: 4px;
  position: absolute;
  z-index: 9;
  left: 0;
  top: 0;
  background: #fff;
}
.white::after {
  content: " ";
  position: absolute;
  top: 0;
  right: -8px;
  border-width: 4px 8px;
  border-style: solid;
  border-color: #fff transparent transparent transparent;
}
.starNav {
  width: 100%;
  height: 36px;
  margin-top: 3px;
  display: flex;
  flex-direction: row;
  align-items: center;
  border-bottom: 1px solid #40382a;
  box-sizing: border-box;
}
.malecelebrity {
  margin-left: 32px;
  color: #c2c2c2;
  font-size: 14px;
  line-height: 20px;
  // font-weight: bold;
  position: relative;
}
.smalecelebrity {
  margin-left: 53px;
  color: #c2c2c2;
  font-size: 14px;
  line-height: 20px;
  // font-weight: bold;
  position: relative;
}
.smalecelebritys {
  margin-left: auto;
  margin-right: 46px;
  color: #c2c2c2;
  line-height: 20px;
  font-size: 14px;
  // font-weight: bold;
  position: relative;
}
.malecelebritys {
  margin-left: auto;
  margin-right: 32px;
  color: #c2c2c2;
  line-height: 20px;
  font-size: 14px;
  // font-weight: bold;
  position: relative;
}
.starActive {
  background: linear-gradient(to bottom, #beab4c, #b88d00);
}
.ActiveLine {
  width: 30px;
  height: 4px;
  // background: linear-gradient(to bottom,#BEAB4C,#B88D00);
  background-color: #262626;
  border-radius: 91px;
  position: absolute;
  top: 24px;
  left: 34px;
}
.ActiveLines {
  width: 30px;
  height: 4px;
  // background: linear-gradient(to bottom,#BEAB4C,#B88D00);
  background-color: #262626;
  border-radius: 91px;
  position: absolute;
  top: 24px;
  left: 13px;
}
.ActiveLiness {
  width: 30px;
  height: 4px;
  // background: linear-gradient(to bottom,#BEAB4C,#B88D00);
  background-color: #262626;
  border-radius: 91px;
  position: absolute;
  top: 24px;
  left: 20px;
}
.ranksbox {
  width: 100%;
  height: auto;
  margin-top: 1px;
}
.EpisodesListbox {
  width: 100%;
  height: auto;
  margin-top: 7px;
}
.Episode {
  width: 339px;
  height: auto;
  display: flex;
  justify-content: space-between;
  margin-left: 18px;
  flex-direction: row;
  flex-wrap: wrap;
}
.EpisodesLists {
  width: 106px;
  height: auto;
  margin-top: 15px;
  position: relative;
}
.Episodesnum {
  width: 100%;
  height: 14px;
  line-height: 14px;
  padding-left: 7px;
  display: flex;
  align-items: center;
  position: absolute;
  top: 141px;
  left: 0;
  color: #ffffff;
  font-size: 10px;
  z-index: 666;
}
.EpisodesIcon {
  width: 12px;
  height: 14px;
  margin-right: 1px;
}
.EpisodeCopy {
  text-align: center;
  width: 100px;
  height: 18px;
  font-size: 13px;
  font-family: PingFang SC;
  // font-weight: bold;
  line-height: 18px;
  color: #c2c2c2;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  margin-top: 5px;
}
.EpisodesCover {
  width: 106px;
  height: 159px;
  border-radius: 10px;
  overflow: hidden;
}
.more {
  color: #58503a;
  font-size: 14px;
  line-height: 20px;
  margin-left: 146px;
  margin-top: 16px;
}
.ranklist {
  display: flex;
  align-items: center;
  flex-direction: row;
  width: 100%;
  margin-top: 18px;
  height: 59px;
}
.Starranking {
  width: auto;
  height: 100%;
  margin-left: 18px;
}
.TOPIcon {
  color: #ffffff;
  font-size: 12px;
  line-height: 17px;
  margin-top: 12px;
}
.rankingbox {
  margin-top: 1px;
  width: auto;
  height: 15px;
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: row;
}
.ranking {
  width: auto;
  position: relative;
  // left: -4px;
  top: -8px;
  height: 14px;
}

.position {
  position: relative;
  left: -5px;
  // top: -8px;
}
.positions {
  position: relative;
  left: -10px;
  // top: -8px;
}
.ranks {
  width: 14px;
  height: 14px;
}
.starAvatar {
  width: 59px;
  height: 59px;
  border-radius: 50%;
  border: 2px solid #363636;
  box-sizing: border-box;
  margin-left: 9px;
  overflow: hidden;
}
.starinformation {
  margin-left: 13px;
  width: auto;
}
.starname {
  color: #dedede;
  font-size: 15px;
  line-height: 21px;
}
.starsname {
  width: 125px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  color: #dedede;
  font-size: 15px;
  line-height: 21px;
}
.starsIcon {
  width: 14px;
  height: 14px;
  margin-right: 2px;
}
.starsNum {
  color: #606060;
  font-size: 12px;
  height: 17px;
  display: flex;
  align-items: center;
  margin-left: 1px;
  line-height: 30px;
}
.Giveoutstars {
  display: flex;
  justify-content: center;
  border-radius: 120px;
  align-items: center;
  width: 71px;
  height: 29px;
  background: linear-gradient(to bottom, #423a2c, #010101);
  margin-left: auto;
  margin-right: 18px;
  // box-shadow: 0px 0px 6px rgba(255, 152, 177, 0.39);
  // line-height: 40px;
}
.Episodestars {
  display: flex;
  justify-content: center;
  border-radius: 120px;
  align-items: center;
  width: 71px;
  height: 29px;
  background: linear-gradient(to bottom, #423a2c, #010101);
  margin-left: auto;
  margin-right: 18px;
  margin-top: 4px;
  // box-shadow: 0px 0px 6px rgba(255, 152, 177, 0.39);
  // line-height: 40px;
}
.Giveoutstarss {
  font-size: 14px;
  color: #fff;
  line-height: 29px;
}
.GiveoutstarsIcon {
  width: 18px;
  height: 18px;
  margin-left: 3px;
}
.userbox {
  width: 100%;
  height: 48px;
  display: flex;
  flex-direction: row;
  margin-top: 25px;
}
.login-box {
  width: 100%;
  height: 72px;
  display: flex;
  flex-direction: row;
  // align-items: center;
  background: url("https://activity-1254361794.file.myqcloud.com/outsource/prize/login-bg.png");
  background-size: 100% auto;
  position: fixed;
  left: 0;
  bottom: 0;
  z-index: 899;
}
.gives {
  width: 80px;
  height: 33px;
  background: linear-gradient(to bottom, #d1ad78, #bfa867);
  display: flex;
  justify-content: center;
  align-items: center;
  margin-left: auto;
  margin-right: 18px;
  border-radius: 18px;
  color: #fff;
  position: relative;
  font-size: 16px;
  margin-top: 25px;
}
.gisves {
  width: 80px;
  height: 33px;
  background: linear-gradient(to bottom, #40382a, #40382a);
  display: flex;
  justify-content: center;
  align-items: center;
  margin-left: auto;
  margin-right: 18px;
  border-radius: 18px;
  color: #fff;
  position: relative;
  font-size: 16px;
  margin-top: 8px;
}
.givesIcon {
  width: 20px;
  height: 20px;
  margin-left: 4px;
}
.vipIcon {
  width: 31px;
  height: 13px;
  background: url("https://activity-1254361794.file.myqcloud.com/outsource/prize/vip.png");
  background-size: 100% auto;
  position: absolute;
  right: -7px;
  top: -7px;
}
.bg {
  display: block;
  width: 100%;
  height: auto;
}
.date {
  display: block;
  // width: 100%;
  height: auto;
  transform: translateY(-172px);
}
.nav {
  position: absolute;
  font-weight: bold;
  top: -22px;
  left: 0 px;
  width: 138px;
  height: 77px;
  background: url("https://activity-1254361794.file.myqcloud.com/outsource/nav.png");
  background-size: 100% auto;
  display: flex;
  justify-content: center;
  align-items: center;
  font-size: 18px;
  color: #fff;
  line-height: 20px;
}
.episodevoting-nav {
  position: absolute;
  top: -54px;
  left: 0 px;
  width: 138px;
  height: 77px;
  background: url("https://activity-1254361794.file.myqcloud.com/outsource/nav.png");
  background-size: 100% auto;
  display: flex;
  justify-content: center;
  align-items: center;
  font-size: 18px;
  color: #fff;
  line-height: 20px;
}
.vote {
  width: 368px;
  height: 201px;
  margin: 0 auto;
  position: relative;
  background: url("https://activity-1254361794.file.myqcloud.com/outsource/nav-bg.png");
  background-size: 100% auto;
  transform: translateY(-146px);
}
.vote-left {
  width: 64px;
  height: 27px;
  background: url("https://activity-1254361794.file.myqcloud.com/outsource/vote-left.png");
  background-size: 100% auto;
  position: absolute;
  top: 0px;
  right: 8px;
}
.vote-right {
  width: 58px;
  height: 22px;
  background: url("https://activity-1254361794.file.myqcloud.com/outsource/vote-right.png");
  background-size: 100% auto;
  position: absolute;
  bottom: 5px;
  left: 6px;
}
.rules {
  width: 308px;
  height: 110px;
  padding-top: 47px;
  margin-left: 30px;
}

.rule {
  width: 100%;
  height: auto;
  color: #47f2ff;
  font-size: 12px;
  flex-wrap: wrap;
  line-height: 20px;
}
.sort {
  width: 14px;
  height: 13px;
  display: inline-block;
  margin-right: 4px;
  position: relative;
  top: 2px;
}
.episodevoting {
  width: 368px;
  height: 91px;
  display: flex;
  align-items: center;
  margin: 0 auto;
  position: relative;
  background: url("https://activity-1254361794.file.myqcloud.com/outsource/episodevoting.png");
  background-size: 100% auto;
  transform: translateY(-91px);
}
.episodevoting-left {
  width: 47px;
  height: 18px;
  position: absolute;
  background: url("https://activity-1254361794.file.myqcloud.com/outsource/episodevoting-left.png");
  background-size: 100% auto;
  top: 4px;
  right: 11px;
}
.episodevoting-right {
  width: 37px;
  height: 16px;
  position: absolute;
  background: url("https://activity-1254361794.file.myqcloud.com/outsource/episodevoting-right.png");
  background-size: 100% auto;
  bottom: 3px;
  left: 11px;
}
.user_avtar {
  width: 48px;
  height: 48px;
  border-radius: 50%;
  // border: 1px solid #219fff;
  margin-top: 13px;
  overflow: hidden;
}
.users_avtar {
  width: 48px;
  height: 48px;
  border-radius: 50%;
  overflow: hidden;
  margin-left: 18px;
}
image {
  width: 100%;
  height: 100%;
  z-index: 456;
}
.login {
  width: 74px;
  height: 30px;
  margin-top: 23px;
  border-radius: 63px;
  background-color: #ffb636;
  color: #ffffff;
  display: flex;
  justify-content: center;
  align-items: center;
  margin-left: auto;
  margin-right: 18px;
  font-size: 18px;
  line-height: 25px;
  font-weight: bold;
}
.logsin {
  width: 80px;
  height: 33px;
  margin-top: 8px;
  border-radius: 18px;
  background: linear-gradient(to bottom, #40382a, #030302);
  color: #ffffff;
  display: flex;
  justify-content: center;
  align-items: center;
  margin-left: auto;
  margin-right: 24px;
  font-size: 16px;
  line-height: 32px;
}
.userInfo {
  width: auto;
  max-width: 120px;
  height: auto;
  margin-left: 8px;
}
.userInfos {
  width: auto;
  max-width: 130px;
  height: auto;
  margin-left: 8px;
}
.nicksname {
  color: #ffffff;
  font-size: 15px;
  line-height: 20px;
  margin-top: 14px;
}
.nickname {
  color: #5e5e5e;
  font-size: 15px;
  line-height: 20px;
  margin-top: 27px;
}
.nicknames {
  width: 120px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  color: #5e5e5e;
  font-size: 15px;
  line-height: 20px;
  margin-top: 19px;
}
.nicknamess {
  width: 120px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  color: #5e5e5e;
  font-size: 15px;
  line-height: 20px;
}
.brick {
  color: #7d4b00;
  font-size: 13px;
  line-height: 20px;
}
.color {
  color: #ffdd00;
}
.colors {
  color: #ffffff;
  margin-top: 6px;
}
.bricknum {
  width: 66px;
  height: 62px;
  display: flex;
  flex-direction: row;
  justify-content: center;
  margin-left: auto;
  margin-right: 24px;
  background: url("https://activity-1254361794.file.myqcloud.com/outsource/brick.png");
  background-size: 100% auto;
}
.numIcon {
  // padding-top: 38px;
  width: 11px;
  height: 16px;
  position: relative;
}
.num {
  padding-top: 38px;
  width: 16px;
  height: 16px;
  position: absolute;
  top: 0;
  left: -5px;
}
.nums {
  padding-top: 38px;
  width: 16px;
  height: 16px;
}
.Detailedrules {
  float: right;
  width: 72px;
  height: 17px;
}
.EpisodesList {
  width: 332px;
  height: auto;
  flex-wrap: wrap;
  margin-left: 22px;
  transform: translateY(-70px);
  display: flex;
  flex-direction: row;
  justify-content: space-between;
}
.list {
  width: 102px;
  position: relative;
  height: auto;
  margin-bottom: 10px;
}
.Cover {
  width: 102px;
  position: relative;
  height: 152px;
  background: rgba(35, 88, 88, 0.31);
  box-shadow: 0px 0px 7px rgba(95, 135, 196, 0.52);
  opacity: 1;
  border-radius: 10px;
  overflow: hidden;
}
.mask {
  position: absolute;
  top: 0;
  left: 0;
  z-index: 9;
  width: 106px;
  height: 159px;
  background: linear-gradient(
    180deg,
    rgba(0, 0, 0, 0) 0%,
    rgba(12, 12, 12, 0.68) 100%
  );
}
.Details {
  width: 100%;
  height: 13px;
  line-height: 13px;
  height: 13px;
  display: flex;
  align-items: center;
}
.votes-num {
  color: #21e8ff;
  font-size: 9px;
  line-height: 16px;
  font-weight: bold;
}
.Detail {
  color: #21e8ff;
  font-size: 8px;
  line-height: 9px;
  margin-left: auto;
  margin-right: 11rpx;
}
.Give_away {
  width: 82px;
  height: 27px;
  background: linear-gradient(166deg, #4791ff 0%, #48d9ff 79%, #00dccd 100%);
  opacity: 1;
  font-weight: bold;
  display: flex;
  justify-content: center;
  text-align: center;
  align-items: center;
  margin: 0 auto;
  color: #ffffff;
  font-size: 9px;
  line-height: 13px;
  margin-top: 5px;
  border-radius: 20px;
}
.buy_away {
  width: 82px;
  position: relative;
  height: 27px;
  background: linear-gradient(to right, #ffe70a, #ff4600);
  opacity: 1;
  font-weight: bold;
  display: flex;
  justify-content: center;
  text-align: center;
  align-items: center;
  margin: 0 auto;
  color: #ffffff;
  font-size: 9px;
  line-height: 13px;
  margin-top: 5px;
  border-radius: 20px;
}
.buy_away_title {
  color: #ffffff;
  font-size: 9px;
  font-weight: bold;
  transform: translateX(-3px);
}
.Vip {
  position: absolute;
  top: -3px;
  right: -3px;
  width: 26px;
  height: 11px;
  border-radius: 40px;
  background: url("https://activity-1254361794.file.myqcloud.com/outsource/vip.png");
  background-size: 100% auto;
}
.Give_away_icon {
  width: 25px;
  height: 24px;
  transform: translateX(-1px);
}
.reward {
  width: 368px;
  height: 153px;
  margin: 0 auto;
  position: relative;
  background: url("https://activity-1254361794.file.myqcloud.com/outsource/reward-bg.png");
  background-size: 100% auto;
  transform: translateY(-30px);
}
.reward-left {
  width: 49px;
  height: 28px;
  background: url("https://activity-1254361794.file.myqcloud.com/outsource/reward-left.png");
  background-size: 100% auto;
  position: absolute;
  bottom: 0px;
  left: 6px;
}
.reward-right {
  width: 65px;
  height: 29px;
  background: url("https://activity-1254361794.file.myqcloud.com/outsource/reward-right.png");
  background-size: 100% auto;
  position: absolute;
  top: 0px;
  right: 7px;
}
.bottom {
  width: 100%;
  height: 17px;
  display: flex;
  justify-content: center;
  align-items: center;
}
.link {
  display: flex;
  align-items: center;
  justify-content: center;
  letter-spacing: 1px;
  a {
    font-size: 12px;
    font-family: PingFangSC-Regular, PingFang SC;
    font-weight: 500;
    color: #346794;
  }
  span {
    font-size: 12px;
    font-family: PingFangSC-Regular, PingFang SC;
    font-weight: 500;
    color: #346794;
    margin: 0 3px;
  }
}
.external_login {
  width: 269px;
  height: 222px;
  background: url("https://activity-1254361794.file.myqcloud.com/outsource/external_login.png");
  background-size: 100% auto;
}
.external_login_title {
  font-size: 15px;
  color: #787878;
  line-height: 21px;
  width: 100%;
  text-align: center;
  margin-top: 25px;
}

.van-form {
  width: 250px;
  margin-left: 10px;
  margin-top: 12px;
}
.van-cell {
  width: 188px;
  margin-left: 31px;
  padding-bottom: 4px;
  padding-left: 0;
  position: relative;
}
.van-cell:not(:last-child)::after {
  border-bottom: 1px solid #c2c2c2;
  position: absolute;
  left: 0;
}
.logins {
  width: 96px;
  height: 38px;
  margin-left: 80px;
  margin-top: 12px;
  display: flex;
  justify-content: center;
  align-items: center;
  color: #ffffff;
  font-size: 17px;
  line-height: 24px;
  background: url("https://activity-1254361794.file.myqcloud.com/outsource/prize/login.png");
  background-size: 100% auto;
}
.title {
  text-align: center;
  font-size: 18px;
  font-weight: 800;
  height: 40px;
  line-height: 40px;
}
.codetxt {
  width: 100px;
  height: 20px;
  position: absolute;
  right: -40px;
  top: 0;
  height: 20px;
  color: #40382a;
  font-size: 14px;
  font-weight: bold;
  // line-height: 20px;
  display: flex;
  align-items: center;
}
.codeline {
  width: 1px;
  height: 13px;
  margin-right: 5px;
  background: #c2c2c2;
  display: inline-block;
}
.van-overlay {
  background-color: rgba(0, 0, 0, 0.85);
}
.sharebox {
  width: 191px;
  height: 143px;
  position: fixed;
  top: 27px;
  right: 37px;
  z-index: 30000;
}
.wxshare {
  width: 100%;
  height: 100%;
}
.love {
  color: #606060;
  font-size: 12px;
}
.Contribution {
  display: flex;
  align-items: center;
  margin-left: auto;
  margin-right: 18px;
  width: auto;
  height: 100%;
  color: #606060;
  font-size: 12px;
}
.title_box {
  width: 100%;
  padding-top: 24px;
  height: 21px;
  display: flex;
  flex-direction: row;
  align-items: center;
}
.Playtitle {
  height: 21px;
  display: flex;
  flex-direction: row;
  align-items: center;
  color: #232148;
  font-size: 15px;
  font-weight: bold;
  line-height: 16px;
  margin-left: 32px;
}
.down {
  width: 15px;
  height: 10px;
  background: url("https://activity-1254361794.file.myqcloud.com/outsource/down.png");
  background-size: 100% auto;
  position: absolute;
  top: 24px;
  right: 36px;
}
.Introduction {
  position: relative;
  width: 305px;
  height: 34px;
  margin-left: 38px;
  color: #8f8f8f;
  font-size: 12px;
  flex-wrap: wrap;
  line-height: 17px;
  margin-top: 4px;
}
.statistics {
  position: absolute;
  top: 18px;
  right: 4px;
  width: auto;
  min-width: 85px;
  text-align: center;
  // line-height: 46px;
  padding: 0 5px;
  height: 16px;
  border-radius: 9px;
  border: 1px solid #ffc813;
  color: #ff7700;
  font-size: 10px;
}
.Beyond {
  color: #ff0000;
}
.Votess {
  color: #8f8f8f;
  font-size: 10px;
}
.Beyonds {
  color: #ff0000;
  font-size: 12px;
  font-weight: bold;
}
.RankBox {
  width: 302px;
  margin-left: 38px;
  height: auto;
  margin-top: 10px;
}
.Rank {
  width: 100%;
  height: 57px;
  display: flex;
  align-items: center;
  border-bottom: 1px solid #f1f1f1;
}
.Rank_num {
  color: #5a5a5a;
  font-size: 15px;
}
.profile_picture {
  width: 45px;
  height: 45px;
  border-radius: 50%;
  margin-left: 12px;
  overflow: hidden;
}
.profile_name {
  display: flex;
  flex-wrap: wrap;
  max-width: 120px;
  width: auto;
  height: auto;
  color: #5a5a5a;
  font-size: 14px;
  margin-left: 13px;
}
.gift_icon {
  width: 27px;
  height: 25px;
}
.gift_box {
  width: auto;
  margin-left: auto;
  margin-right: 0;
  height: 27px;
  justify-content: center;
  box-sizing: border-box;
  display: flex;
  flex-direction: row;
  border-bottom: 3px solid #ffc813;
}
.gift_num {
  font-size: 13px;
  color: #ff7700;
  height: 27px;
  width: auto;
  line-height: 27px;
}
//点击购买星星弹窗
.buy-modal {
  width: 100%;
  height: 326px;
  z-index: 4566666654646;
}
.buy-list-box {
  width: 311px;
  margin-top: 10px;
  margin-left: 32px;
  height: auto;
  display: flex;
  justify-content: space-between;
  flex-wrap: wrap;
}
.buy-list {
  width: 149px;
  height: 117px;
  background-color: #f6f6f6;
  border-radius: 10px;
  position: relative;
  margin-bottom: 10px;
}
.gift_vip1 {
  position: absolute;
  left: 36px;
  top: 19px;
  width: 76px;
  height: 47px;
}
.gift_vip2 {
  position: absolute;
  left: 30px;
  top: 21px;
  width: 91px;
  height: 45px;
}
.gift_vip3 {
  position: absolute;
  left: 30px;
  top: 17px;
  width: 91px;
  height: 49px;
}
.gift_vip4 {
  position: absolute;
  left: 29px;
  top: 17px;
  width: 92px;
  height: 49px;
}
.giveaway {
  width: 100%;
  text-align: center;
  height: 17px;
  line-height: 17px;
  margin-top: 59px;
  color: #232148;
  font-size: 12px;
  font-weight: bold;
}
.give {
  background: linear-gradient(to bottom, #40382a, #030302);
  width: 69px;
  height: 28px;
  border-radius: 63px;
  display: flex;
  justify-content: center;
  align-items: center;
  margin-left: 40px;
  margin-top: 67px;
  color: #ffffff;
  font-size: 10px;
  font-weight: bold;
}
.days {
  color: #ff5b5b;
  font-size: 12px;
  font-weight: bold;
}

.confirmPopup {
  width: 254px;
  height: 182px;
  background-color: #fff;
  border-radius: 25px;
}
.confirmPopup_title {
  font-size: 15px;
  color: #787878;
  line-height: 21px;
  width: 100%;
  text-align: center;
  margin-top: 25px;
  // font-weight: bold;
}
.button_box {
  margin-left: 17px;
  width: 220px;
  margin-top: 14px;
  height: 33px;
  display: flex;
  flex-direction: row;
  justify-content: space-evenly;
}
.button {
  width: 64px;
  height: 33px;
  display: flex;
  justify-content: center;
  align-items: center;
  color: #ffffff;
  font-size: 15px;
  border-radius: 5px;
  border: 1px solid #00fff7;
  background-color: #6bf0ff;
  //  background-color: FFF;
}
.button1 {
  width: 64px;
  height: 33px;
  display: flex;
  justify-content: center;
  align-items: center;
  color: #757575;
  font-size: 15px;
  border-radius: 5px;
  box-sizing: border-box;
  border: 2px solid #40382a;
  // background-color: #c9c9c9;
  background-color: FFF;
}
.button2 {
  width: 64px;
  height: 33px;
  display: flex;
  justify-content: center;
  align-items: center;
  color: #757575;
  font-size: 15px;
  background-color: FFF;
  box-sizing: border-box;
  border: 2px solid #40382a;
  border-radius: 5px;
  // box-shadow: 0 5px 6px rgba(0,0,0,0.23)
}
.select_active {
  background-color: #40382a;
  border: none;
  color: #fff;
}
.select_actives {
  background-color: #cccccc;
  border: none;
  color: #757575;
}
.button_icon {
  width: 26px;
  height: 24px;
}
.foot {
  display: flex;
  width: 80%;
  margin-left: 10%;
  height: 32px;
  justify-content: space-around;
  flex-direction: row;
  margin-top: 27px;
}
.cancel {
  background-color: #ffffff;
  width: 80px;
  height: 32px;
  display: flex;
  justify-content: center;
  align-items: center;
  border: 2px solid #40382a;
  border-radius: 63px;
  color: #232148;
  font-size: 13px;
}
.confirm {
  background: linear-gradient(to bottom, #40382a, #030302);
  width: 80px;
  height: 32px;
  display: flex;
  justify-content: center;
  align-items: center;
  // border: 2px solid #77cdff;
  border-radius: 63px;
  color: #ffffff;
  font-size: 13px;
}

//详细规则
.rulesBox {
  width: 254px;
  height: 430px;
  background-color: #fff;
  border-radius: 25px;
}
.rules_title {
  width: 100%;
  height: 24px;
  text-align: center;
  // font-weight: bold;
  font-size: 17px;
  color: #787878;
  margin-top: 15px;
}
.line {
  width: 219px;
  height: 1px;
  margin-left: 17px;
  display: block;
  margin-top: 6px;
}
.content {
  width: 219px;
  height: 300px;
  overflow: scroll;
  margin-left: 17px;
  display: block;
  margin-top: 6px;
  padding-bottom: 10px;
}
.content_text {
  font-size: 12px;
  color: #1E1E1E;
  font-weight: bold;
  line-height: 16px;
  flex-wrap: wrap;
  letter-spacing:-1px;
  // margin-bottom: 2px;
}
.content_textss{
  color: #BEA04C;
  font-size: 12px;
  margin-top: 7px;
}
.contents_text{
  color: #1E1E1E;
  font-size: 12px;
  font-weight: bold;
}
.ruleLeft{
  padding-left: 15px;
}
.ruleLefts{
  text-indent:25px;
  letter-spacing:0;
}
.content_texts{
  background-color: #BEA04C;
  width: 56px;
  display: flex;
  height: 19px;
  color: #FFFFFF;
  font-size: 12px;
  margin-top: 6px;
  justify-content: center;
  align-items: center;
}
.yuan {
  width: 7px;
  height: 7px;
  margin-right: 5px;
}
.table {
  display: block;
  margin-top: 10px;
  width: 100%;
  height: 115px;
}
.good {
  width: 96px;
  height: 38px;
  display: flex;
  justify-content: center;
  align-items: center;
  margin-left: 79px;
  background: linear-gradient(to bottom, #40382a, #40382a);
  color: #ffffff;
  font-size: 17px;
  margin-top: 13px;
  border-radius: 63px;
}
.active {
  width: 100px;
  height: 20px;
  position: absolute;
  right: -28px;
  top: 0;
  height: 20px;
  // color: #FF6D6D;
  font-size: 14px;
  font-weight: bold;
  // line-height: 20px;
  display: flex;
  align-items: center;
  color: #cecece;
}
.mddOut {
  width: 254px;
  min-height: 120px;
  height: auto;
  border-radius: 25px;
  background-color: #fff;
}
.isOut{
  width: 254px;
  min-height: 150px;
  height: auto;
  border-radius: 25px;
  background-color: #fff;
}
.mddOuts {
  width: 100%;
  height: 100vh;
  position: fixed;
  background-color: transparent;
  z-index: 2001;
  left: 0;
  top: 0;
}
.mddOut_title {
  width: 100%;
  height: 24px;
  line-height: 24px;
  text-align: center;
  color: #232148;
  font-size: 17px;
  line-height: 24px;
  margin-top: 22px;
}
.mddOut_button {
  background: linear-gradient(to bottom, #40382a, #030302);
  width: 96px;
  height: 38px;
  display: flex;
  justify-content: center;
  align-items: center;
  border-radius: 63px;
  color: #ffffff;
  font-size: 17px;
  letter-spacing: 12;
  margin-top: 15px;
  margin-left: 79px;
}
.small_title {
  font-size: 16px;
  font-weight: 600;
  line-height: 30px;
}
.nav_title {
  font-size: 14px;
}
.Bulletframe {
  width: 259px;
  height: auto;
  min-height: 136px;
  background-color: #ffffff;
  border-radius: 25px;
}
.Bulletframe_title {
  color: #ffae21;
  font-size: 16px;
  margin-top: 20px;
  text-align: center;
}
.Bulletframe_titles {
  color: #787878;
  font-size: 15px;
  margin-top: 4px;
  text-align: center;
}
.usershare {
  margin-top: 21px;
  color: #787878;
  font-size: 15px;
  width: 152px;
  text-align: center;
  height: auto;
  margin-left: 59px;
  flex-wrap: wrap;
}
.friendNames {
  color: #787878;
  font-size: 15px;
  width: 152px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowra;
}
.bottom {
  margin-bottom: 28px;
}
.info {
  font-size: 14px;
}
.info span {
  font-weight: 600;
}
a {
  word-wrap: break-word;
}
.avatar {
  width: 40px;
  height: 40px;
  border-radius: 50%;
  border: 1px solid #ffd676;
  margin-right: 6px;
}
.img {
  width: 100%;
  height: 100%;
  border-radius: 50%;
}
.sharenumbox {
  width: 339px;
  height: 26px;
  display: flex;
  margin-left: 18px;
  align-items: center;
  flex-direction: row;
  border-radius: 39px;
  margin-top: 9px;
  background-color: #231d04;
  // background-color: red;
}
.sharetitle {
  width: auto;
  color: #ffffff;
  font-size: 11px;
  margin-left: 10px;
}
.sharetitles {
  width: auto;
  flex-wrap: nowrap;
  color: #ffffff;
  font-size: 11px;
  margin-left: auto;
  margin-right: 2px;
}
.sharenum {
  color: #ffae21;
  font-size: 11px;
  margin-right: 5px;
  width: auto;
}
.sharebutton {
  width: 43px;
  margin-right: 0;
  height: 26px;
  background-color: #ffc117;
  border-radius: 23px;
  color: #000000;
  font-size: 9px;
  display: flex;
  justify-content: center;
  align-items: center;
  font-weight: bold;
}
.mddlogo {
  width: 45px;
  height: 45px;
  margin-top: 14px;
  margin-left: 25px;
}
.sharestitle {
  width: 130px;
  height: auto;
  flex-wrap: wrap;
  color: #030303;
  font-size: 13px;
  font-weight: bold;
  margin-left: 7px;
  margin-top: 20px;
}
.friendName {
  color: #030303;
  font-size: 13px;
  font-weight: bold;
  width: 130px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
.mddlink {
  display: block;
  width: 80px;
  height: 33px;
  margin-left: auto;
  margin-right: 25px;
  margin-top: 24px;
}
</style>
